<template>
  <div id="registration-user">
    <!-- ===== RESERVATION DETAILS (FULL PAGE) ===== -->
    <ReservationDetails v-if="(activeTab === 'reservations' || activeTab == null || activeTab === 'club-statut' || activeTab === 'club-offres') && showDetail" :reservation="selectedResa" :user="userInfo"
      @back="showDetail = false" />

    <!-- ===== DASHBOARD LAYOUT ===== -->
    <div v-else class="dashboard-layout">
      <!-- Mobile top bar -->
      <div class="mobile-topbar" v-if="isMobile">
        <button class="mobile-menu-btn" @click="mobileMenuOpen = !mobileMenuOpen">
          <span class="hamburger-icon" style="font-size: 35px;">&#9776;</span>
        </button>
        <div class="mobile-user-info" @click="activeTab = null">
          <div class="avatar-circle">{{ userInitials }}</div>
          <span class="mobile-username">{{ userInfo.first_name }} {{ userInfo.last_name }}</span>
        </div>
      </div>

      <!-- Mobile drawer overlay -->
      <div v-if="isMobile && mobileMenuOpen" class="mobile-overlay" @click="mobileMenuOpen = false"></div>
      <!-- LEFT SIDEBAR -->
      <aside class="sidebar" :class="{ 'sidebar-open': mobileMenuOpen }">
        <!-- User Profile Header -->
        <div class="sidebar-user-header" @click="activeTab = null">
          <div class="avatar-circle large">{{ userInitials }}</div>
          <div class="sidebar-user-details">
            <p class="sidebar-greeting raleway-semi-p15">Bonjour {{ userInfo.first_name }} {{ userInfo.last_name }}</p>
            <p class="sidebar-level raleway-medi-p11">{{ userInfo.loyalty_status || 'MEMBRE' }} - <span
                class="raleway-reg-p11 text-lowercase" style="color: black;">{{ userInfo.loyalty_points || 0 }}
                points</span></p>
          </div>
        </div>

        <!-- Navigation Menu -->
        <nav class="sidebar-nav">
          <!-- MON PROFIL -->
          <div class="nav-item"
            :class="{ active: activeTab === 'profil' || activeTab === 'profil-info' || activeTab === 'profil-password' }">
            <div class="nav-item-header" @click="toggleProfilMenu">
              <span class="nav-icon">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="18" height="19" viewBox="0 0 21.532 22.595">
                  <defs>
                    <clipPath id="clip-path-profile">
                      <path id="Tracé_25" data-name="Tracé 25" d="M14.668,43H36.2V55.02H14.668Zm0,0" transform="translate(-14.668 -43)"/>
                    </clipPath>
                    <clipPath id="clip-path-profile-2">
                      <path id="Tracé_27" data-name="Tracé 27" d="M28,13.164H40.051V25.157H28Zm0,0" transform="translate(-28 -13.164)"/>
                    </clipPath>
                  </defs>
                  <g id="_1" data-name="1" transform="translate(-14.668 -13.164)">
                    <g id="Groupe_8" data-name="Groupe 8" transform="translate(14.668 23.739)" clip-path="url(#clip-path-profile)">
                      <path id="Tracé_24" data-name="Tracé 24" d="M32.72,45.312,30.89,44l-.624.875,1.829,1.315a7.255,7.255,0,0,1,3.029,5.894V54a.537.537,0,0,1-.537.536H16.293A.537.537,0,0,1,15.756,54V51.98a7.29,7.29,0,0,1,2.9-5.8l1.866-1.4-.649-.861-1.866,1.4a8.359,8.359,0,0,0-3.33,6.658V54a1.614,1.614,0,0,0,1.617,1.612H34.586A1.618,1.618,0,0,0,36.2,53.995V52.077A8.336,8.336,0,0,0,32.72,45.312Zm0,0" transform="translate(-14.673 -43.59)" fill="#231f20"/>
                    </g>
                    <g id="Groupe_9" data-name="Groupe 9" transform="translate(19.393 13.164)" clip-path="url(#clip-path-profile-2)">
                      <path id="Tracé_26" data-name="Tracé 26" d="M34.263,25a5.917,5.917,0,1,0-5.919-5.917A5.922,5.922,0,0,0,34.263,25Zm0-10.76a4.843,4.843,0,1,1-4.844,4.843A4.854,4.854,0,0,1,34.263,14.238Zm0,0" transform="translate(-28.222 -13.164)" fill="#231f20"/>
                    </g>
                  </g>
                </svg>
              </span>
              <span class="nav-label">MON PROFIL</span>
              <span class="nav-chevron" :class="{ 'rotated': profilMenuOpen }">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <polyline points="6 9 12 15 18 9" />
                </svg>
              </span>
            </div>
            <div class="nav-subitems" v-show="profilMenuOpen">
              <a href="#" class="nav-subitem" :class="{ active: activeTab === 'profil-info' }"
                @click.prevent="setTab('profil-info')">Mes informations &amp; adresses</a>
              <a href="#" class="nav-subitem" :class="{ active: activeTab === 'profil-password' }"
                @click.prevent="setTab('profil-password')">Réinitialiser mon mot de passe</a>
            </div>
          </div>

          <!-- MES RÉSERVATIONS -->
          <div class="nav-item" :class="{ active: activeTab === 'reservations' }" @click="setTab('reservations')">
            <div class="nav-item-header">
              <span class="nav-icon">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="18" height="17" viewBox="0 0 22 23.878">
                  <defs>
                    <clipPath id="clip-path-cal">
                      <path id="Tracé_29" data-name="Tracé 29" d="M14.406,11.551h22V35.429h-22Zm0,0" transform="translate(-14.406 -11.551)"/>
                    </clipPath>
                  </defs>
                  <g id="_2" data-name="2" transform="translate(-14.406 -11.551)">
                    <g id="Groupe_10" data-name="Groupe 10" transform="translate(14.406 11.551)" clip-path="url(#clip-path-cal)">
                      <path id="Tracé_28" data-name="Tracé 28" d="M36.4,18.958a.413.413,0,0,0-.013-.1c-.007-.829-.02-1.5-.035-1.928a3.448,3.448,0,0,0-1.716-2.947,4.672,4.672,0,0,0-1.246-.52v-1.42a.425.425,0,0,0-.032-.166.435.435,0,0,0-.1-.14.416.416,0,0,0-.141-.094.433.433,0,0,0-.168-.034.426.426,0,0,0-.166.034.421.421,0,0,0-.143.094.431.431,0,0,0-.094.14.426.426,0,0,0-.034.166v1.341H29.786V12.228a.426.426,0,0,0-.034-.166.439.439,0,0,0-.236-.233.432.432,0,0,0-.334,0,.439.439,0,0,0-.236.233.426.426,0,0,0-.034.166v1.156H26.345V12.228a.426.426,0,0,0-.034-.166.427.427,0,0,0-.236-.233.432.432,0,0,0-.334,0,.416.416,0,0,0-.141.094.435.435,0,0,0-.1.14.426.426,0,0,0-.034.166v1.156H22.8V12.228a.426.426,0,0,0-.034-.166.41.41,0,0,0-.094-.14.421.421,0,0,0-.143-.094.426.426,0,0,0-.166-.034.433.433,0,0,0-.168.034.416.416,0,0,0-.141.094.435.435,0,0,0-.1.14.451.451,0,0,0-.032.166v1.156h-2.73V12.043a.426.426,0,0,0-.034-.166.427.427,0,0,0-.236-.233.432.432,0,0,0-.334,0,.415.415,0,0,0-.141.094.435.435,0,0,0-.1.14.426.426,0,0,0-.034.166v1.371a4.257,4.257,0,0,0-3.168,1.6,3.557,3.557,0,0,0-.7,1.675V32.174l0,.029a4.22,4.22,0,0,0,.622,1.561,3.683,3.683,0,0,0,3.064,1.674c.475.021,1.193.029,2.065.029,4.39,0,12.659-.217,13.076-.228h.025l.025,0a3.445,3.445,0,0,0,3.013-2.777l0-.045c0-.1.074-8.847.038-13.366A.515.515,0,0,0,36.4,18.958ZM18.32,14.288v1.386a.426.426,0,0,0,.034.166.435.435,0,0,0,.1.14.441.441,0,0,0,.141.1.45.45,0,0,0,.334,0,.463.463,0,0,0,.143-.1.431.431,0,0,0,.094-.14.426.426,0,0,0,.034-.166V14.25h2.73v1.421a.451.451,0,0,0,.032.166.435.435,0,0,0,.1.14.416.416,0,0,0,.141.094.433.433,0,0,0,.168.034.426.426,0,0,0,.166-.034.421.421,0,0,0,.143-.094.41.41,0,0,0,.094-.14.426.426,0,0,0,.034-.166V14.25h2.676v1.288a.426.426,0,0,0,.034.166.435.435,0,0,0,.1.14.415.415,0,0,0,.141.094.432.432,0,0,0,.334,0,.427.427,0,0,0,.236-.233.426.426,0,0,0,.034-.166V14.25h2.57v1.421a.451.451,0,0,0,.032.166.435.435,0,0,0,.1.14.416.416,0,0,0,.141.094.438.438,0,0,0,.168.034.426.426,0,0,0,.166-.034.421.421,0,0,0,.143-.094.41.41,0,0,0,.094-.14.426.426,0,0,0,.034-.166V14.25h2.729v1.58a.419.419,0,0,0,.034.165.435.435,0,0,0,.236.235.432.432,0,0,0,.334,0,.437.437,0,0,0,.141-.094.435.435,0,0,0,.129-.306V14.358a2.768,2.768,0,0,1,2.089,2.6c.014.362.025.9.032,1.564H15.325V16.753a3.024,3.024,0,0,1,2.995-2.468Zm17.16,18.1c-.2,1.6-2.012,1.954-2.246,1.994-.664.017-12.286.316-15.052.2a2.951,2.951,0,0,1-2.855-2.462V19.388h20.19C35.546,23.853,35.479,31.877,35.479,32.384Zm0,0" transform="translate(-14.436 -11.588)"/>
                    </g>
                    <path id="Tracé_30" data-name="Tracé 30" d="M27.8,41.6h2.9v-2.96H27.8Zm.873-2.093h1.154V40.73H28.674Zm0,0" transform="translate(-8.603 -17.397)"/>
                    <path id="Tracé_31" data-name="Tracé 31" d="M40.926,41.549H43.86V38.637H40.926ZM41.8,39.5h1.188v1.179H41.8Zm0,0" transform="translate(-17.033 -17.397)"/>
                    <path id="Tracé_32" data-name="Tracé 32" d="M56.963,38.637H54.129v2.907h2.834Zm-.872,2.04H55V39.5h1.089Zm0,0" transform="translate(-25.513 -17.397)"/>
                    <path id="Tracé_33" data-name="Tracé 33" d="M54.129,53.025h2.894V50.152H54.129ZM55,51.019h1.149v1.14H55Zm0,0" transform="translate(-25.513 -24.793)"/>
                    <path id="Tracé_34" data-name="Tracé 34" d="M54.129,64.533h2.853V61.7H54.129ZM55,62.567H56.11v1.1H55Zm0,0" transform="translate(-25.513 -32.209)"/>
                    <path id="Tracé_35" data-name="Tracé 35" d="M40.926,64.673h2.881v-2.86H40.926Zm.873-1.994h1.135v1.128H41.8Zm0,0" transform="translate(-17.033 -32.282)"/>
                    <path id="Tracé_36" data-name="Tracé 36" d="M40.926,53.025H43.82V50.152H40.926Zm.873-2.007h1.149v1.14H41.8Zm0,0" transform="translate(-17.033 -24.793)"/>
                    <path id="Tracé_37" data-name="Tracé 37" d="M27.984,53.025h2.781V50.152H27.984Zm.873-2.007h1.035v1.14H28.858Zm0,0" transform="translate(-8.721 -24.793)"/>
                    <path id="Tracé_38" data-name="Tracé 38" d="M27.984,64.46h2.781V61.7H27.984Zm.873-1.893h1.035v1.027H28.858Zm0,0" transform="translate(-8.721 -32.209)"/>
                  </g>
                </svg>

              </span>
              <span class="nav-label">MES RÉSERVATIONS</span>
              <span v-if="pendingCount > 0" class="pending-badge">À VENIR</span>
            </div>
          </div>

          <!-- MA WISHLIST -->
          <div class="nav-item" :class="{ active: activeTab === 'wishlist' }" @click="setTab('wishlist')">
            <div class="nav-item-header">
              <span class="nav-icon">
                <svg width="19" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="4">
                  <path
                    d="M14.834,4a5.48,5.48,0,0,0-4.673,2.622A5.487,5.487,0,0,0,0,9.512C0,15.54,10.161,22.373,10.161,22.373S20.322,15.54,20.322,9.512A5.508,5.508,0,0,0,16.934,4.42a5.467,5.467,0,0,0-2.1-.42Z" />
                </svg>
              </span>
              <span class="nav-label">MA WISHLIST</span>
              <span v-if="wishlistCount > 0" class="wishlist-badge">{{ wishlistCount }}</span>
            </div>
          </div>

          <!-- LE CLUB HORTENSE -->
          <div class="nav-item"
            :class="{ active: activeTab === 'club' || activeTab === 'club-statut' || activeTab === 'club-offres' }">
            <div class="nav-item-header" @click="toggleClubMenu">
              <span class="nav-icon">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="18" height="21" viewBox="0 0 24.625 28.143" fill="none" stroke="currentColor" stroke-width="1.8">
                  <defs>
                    <clipPath id="clip-path-hortense">
                      <path d="M13.41,9H38.035V37.143H13.41Zm0,0"/>
                    </clipPath>
                  </defs>
                  <g transform="translate(-13.41 -9)" clip-path="url(#clip-path-hortense)" fill="none" stroke="currentColor" stroke-width="1.8">
                    <path d="M38.105,26.8a1.33,1.33,0,0,0-.637-.934,1.421,1.421,0,0,0-.417-.171,1.438,1.438,0,0,0-.45-.029,1.392,1.392,0,0,0-.435.116,1.365,1.365,0,0,0-.376.246l-2.719,2.525a2.31,2.31,0,0,1-.884.513,2.278,2.278,0,0,1-1.018.081c-.879-.122-1.585-.231-2.139-.319l.809-.383a1.547,1.547,0,0,0,.444-.308,1.52,1.52,0,0,0,.311-.443,1.546,1.546,0,0,0,.095-1.063,1.593,1.593,0,0,0-.231-.492,1.543,1.543,0,0,0-1.415-.647l-7.546.655a4.993,4.993,0,0,0-3.533,1.968l-1.31,1.727a1.384,1.384,0,0,0-.835-.371,1.378,1.378,0,0,0-.461.037,1.4,1.4,0,0,0-.426.186L14.3,30.1a1.407,1.407,0,0,0-.385.363,1.437,1.437,0,0,0-.263,1.009,1.421,1.421,0,0,0,.157.507l2.379,4.428a1.394,1.394,0,0,0,.382.452,1.409,1.409,0,0,0,.531.257,1.377,1.377,0,0,0,.344.044,1.4,1.4,0,0,0,.789-.241l.756-.492a1.423,1.423,0,0,0,.463-.518,1.4,1.4,0,0,0,.165-.673h8.656a8.1,8.1,0,0,0,1.847-.223,8.2,8.2,0,0,0,1.75-.638,8.176,8.176,0,0,0,2.849-2.367L37.841,27.9A1.325,1.325,0,0,0,38.105,26.8ZM18.45,35.578l-.754.493a.443.443,0,0,1-.171.066.419.419,0,0,1-.185-.008.442.442,0,0,1-.282-.221l-2.38-4.428a.445.445,0,0,1-.035-.322.434.434,0,0,1,.188-.263l.634-.409a.442.442,0,0,1,.24-.069h.1a.4.4,0,0,1,.281.212l2.443,4.251A.961.961,0,0,0,18.6,35a.426.426,0,0,1,.038.318A.416.416,0,0,1,18.45,35.578ZM37.065,27.3l-3.121,4.133a7.159,7.159,0,0,1-5.671,2.814H19.285L17.2,30.638a.475.475,0,0,0,.206-.153l1.339-1.771a3.99,3.99,0,0,1,2.837-1.565l7.546-.673a.561.561,0,0,1,.563.339.53.53,0,0,1,.047.211.559.559,0,0,1-.035.212.567.567,0,0,1-.113.183.533.533,0,0,1-.174.127L23.2,30.5a.471.471,0,0,0-.227.228.476.476,0,0,0-.038.321.483.483,0,0,0,.169.276.472.472,0,0,0,.3.11.527.527,0,0,0,.211-.044l3.817-1.815c.137,0,.579.079,1.095.157.6.093,1.428.226,2.507.379a3.28,3.28,0,0,0,2.707-.841l2.719-2.524a.4.4,0,0,1,.281-.119.4.4,0,0,1,.286.108.4.4,0,0,1,.134.275A.4.4,0,0,1,37.065,27.3ZM19.274,18.84a1.02,1.02,0,0,1,.366.224,1.039,1.039,0,0,1,.218,1.2,2.011,2.011,0,0,0-.177.592,2.038,2.038,0,0,0,.011.617,2.075,2.075,0,0,0,.2.586,2.021,2.021,0,0,0,.365.5,2,2,0,0,0,2.287.392,1.035,1.035,0,0,1,.421-.095,1,1,0,0,1,.423.084,1.017,1.017,0,0,1,.351.252,1.028,1.028,0,0,1,.218.374,2,2,0,0,0,.292.545,1.943,1.943,0,0,0,.444.429,2.007,2.007,0,0,0,2.767-.429,1.991,1.991,0,0,0,.29-.545,1.033,1.033,0,0,1,.224-.366,1.028,1.028,0,0,1,1.194-.223,1.994,1.994,0,0,0,1.2.163,1.979,1.979,0,0,0,.583-.2,2.007,2.007,0,0,0,.5-.363,2.009,2.009,0,0,0,.559-1.083,1.99,1.99,0,0,0,.012-.617,2.045,2.045,0,0,0-.176-.591,1.045,1.045,0,0,1-.1-.418,1.027,1.027,0,0,1,.079-.423,1.054,1.054,0,0,1,.243-.356,1.02,1.02,0,0,1,.366-.224,2.019,2.019,0,0,0,.971-3.066,1.975,1.975,0,0,0-.429-.444,2.025,2.025,0,0,0-.542-.293,1.035,1.035,0,0,1-.689-1,1.045,1.045,0,0,1,.1-.418,2.03,2.03,0,0,0,.168-1.209,2.025,2.025,0,0,0-.2-.586,2.052,2.052,0,0,0-.363-.5,2.021,2.021,0,0,0-.5-.365,1.979,1.979,0,0,0-.583-.2,1.944,1.944,0,0,0-.617-.011,1.989,1.989,0,0,0-.589.176,1.023,1.023,0,0,1-.418.1,1,1,0,0,1-.421-.078.993.993,0,0,1-.354-.243,1.033,1.033,0,0,1-.224-.366,1.953,1.953,0,0,0-.281-.557,1.977,1.977,0,0,0-.441-.44A1.964,1.964,0,0,0,25.855,9a1.984,1.984,0,0,0-.612.092,1.926,1.926,0,0,0-.553.273,1.956,1.956,0,0,0-.444.432,1.978,1.978,0,0,0-.29.547.939.939,0,0,1-.574.609.975.975,0,0,1-.84,0,2.011,2.011,0,0,0-1.2-.162,2.025,2.025,0,0,0-1.444,1.06,2.081,2.081,0,0,0-.2.585,2.044,2.044,0,0,0,.163,1.209,1.026,1.026,0,0,1-.218,1.192,1.02,1.02,0,0,1-.366.224,2.025,2.025,0,0,0-.542.293,1.976,1.976,0,0,0-.429.444,2.056,2.056,0,0,0-.275.553,2.017,2.017,0,0,0,0,1.221,2.065,2.065,0,0,0,.275.554,2.017,2.017,0,0,0,.971.737Zm.33-2.874a2.017,2.017,0,0,0,1.338-1.956,2,2,0,0,0-.2-.814,1.022,1.022,0,0,1-.086-.62,1.034,1.034,0,0,1,.841-.844,1.016,1.016,0,0,1,.618.086,1.978,1.978,0,0,0,.4.145,2.06,2.06,0,0,0,.421.058,1.946,1.946,0,0,0,.421-.032,2.027,2.027,0,0,0,.782-.321,2.037,2.037,0,0,0,.582-.612,2.1,2.1,0,0,0,.182-.383,1.018,1.018,0,0,1,.147-.29,1.051,1.051,0,0,1,.228-.231,1.029,1.029,0,0,1,.289-.147,1.007,1.007,0,0,1,.638,0,1.029,1.029,0,0,1,.289.147,1.051,1.051,0,0,1,.228.231,1.018,1.018,0,0,1,.147.29,1.92,1.92,0,0,0,.182.379,2.025,2.025,0,0,0,.576.608,2.009,2.009,0,0,0,.369.2,1.946,1.946,0,0,0,.4.121,2.027,2.027,0,0,0,.418.034,2.106,2.106,0,0,0,.417-.055,1.918,1.918,0,0,0,.4-.14,1.016,1.016,0,0,1,.618-.086,1.034,1.034,0,0,1,.841.844,1.022,1.022,0,0,1-.085.62,1.975,1.975,0,0,0-.2.814,2.007,2.007,0,0,0,.151.824,2.042,2.042,0,0,0,1.186,1.131,1.029,1.029,0,0,1,.289.147,1.051,1.051,0,0,1,.231.228,1.017,1.017,0,0,1,.147.29,1.035,1.035,0,0,1-.666,1.3,2.049,2.049,0,0,0-.379.18,2.013,2.013,0,0,0-.333.257,1.958,1.958,0,0,0-.273.321,2.112,2.112,0,0,0-.2.369,2.07,2.07,0,0,0-.119.4,2.025,2.025,0,0,0,.163,1.235,1.032,1.032,0,0,1,.1.313,1.04,1.04,0,0,1-.3.907,1.037,1.037,0,0,1-.269.191,1.045,1.045,0,0,1-.643.087,1.015,1.015,0,0,1-.31-.11,2.037,2.037,0,0,0-.4-.142,2.027,2.027,0,0,0-.835-.023,2.039,2.039,0,0,0-.4.119,2.01,2.01,0,0,0-.69.473,1.994,1.994,0,0,0-.257.333,2.068,2.068,0,0,0-.182.38.959.959,0,0,1-.145.287.98.98,0,0,1-.837.4.985.985,0,0,1-.608-.177.94.94,0,0,1-.229-.224,1,1,0,0,1-.145-.287,2.006,2.006,0,0,0-1.128-1.185,1.9,1.9,0,0,0-.77-.153,2.038,2.038,0,0,0-.864.191.954.954,0,0,1-.3.1.989.989,0,0,1-.618-.107.98.98,0,0,1-.252-.2,1.019,1.019,0,0,1-.2-1.176,2.006,2.006,0,0,0,.139-.4,2.033,2.033,0,0,0,.023-.837,2.084,2.084,0,0,0-.119-.4,2.016,2.016,0,0,0-.2-.369,2.1,2.1,0,0,0-.272-.321,2.016,2.016,0,0,0-.334-.255,1.92,1.92,0,0,0-.379-.182,1.029,1.029,0,0,1-.289-.147,1.086,1.086,0,0,1-.231-.228,1.018,1.018,0,0,1-.147-.29,1.038,1.038,0,0,1,.147-.928,1.058,1.058,0,0,1,.231-.229,1.029,1.029,0,0,1,.289-.147Zm4.533.547a1.749,1.749,0,0,0,.334-.034,1.785,1.785,0,0,0,.322-.1,1.751,1.751,0,0,0,.3-.16,1.651,1.651,0,0,0,.26-.214,1.679,1.679,0,0,0,.214-.261,1.636,1.636,0,0,0,.159-.3,1.7,1.7,0,0,0,.1-.322,1.7,1.7,0,0,0,0-.672,1.719,1.719,0,0,0-.1-.324,1.743,1.743,0,0,0-.159-.3,1.835,1.835,0,0,0-.214-.261,1.7,1.7,0,0,0-.557-.373,1.57,1.57,0,0,0-.322-.1,1.634,1.634,0,0,0-.334-.034,1.66,1.66,0,0,0-.336.034,1.629,1.629,0,0,0-.322.1,1.674,1.674,0,0,0-.3.159,1.723,1.723,0,0,0-.632.773,1.613,1.613,0,0,0-.1.324,1.7,1.7,0,0,0,0,.672,1.6,1.6,0,0,0,.1.322,1.636,1.636,0,0,0,.159.3,1.6,1.6,0,0,0,.214.261,1.652,1.652,0,0,0,.26.214,1.682,1.682,0,0,0,.3.16,1.863,1.863,0,0,0,.322.1A1.777,1.777,0,0,0,24.137,16.513Zm0-2.461a.738.738,0,0,1,.281.056.768.768,0,0,1,.24.16.739.739,0,0,1,.159.8.722.722,0,0,1-.4.4.71.71,0,0,1-.281.056.74.74,0,0,1-.521-.215.738.738,0,0,1-.159-.24.743.743,0,0,1,.159-.8.733.733,0,0,1,.521-.217Zm2.7,4.675a1.66,1.66,0,0,0,.034.336,1.7,1.7,0,0,0,.1.322,1.636,1.636,0,0,0,.159.3,1.6,1.6,0,0,0,.214.261,1.732,1.732,0,0,0,.557.374,1.807,1.807,0,0,0,.321.1,1.776,1.776,0,0,0,.336.032,1.748,1.748,0,0,0,.334-.032,1.785,1.785,0,0,0,.322-.1,1.7,1.7,0,0,0,.3-.16,1.651,1.651,0,0,0,.26-.214,1.679,1.679,0,0,0,.214-.261,1.636,1.636,0,0,0,.159-.3,1.7,1.7,0,0,0,.1-.322,1.7,1.7,0,0,0,0-.672,1.685,1.685,0,0,0-.1-.324,1.723,1.723,0,0,0-.632-.773,1.767,1.767,0,0,0-.62-.258A1.748,1.748,0,0,0,28.553,17a1.775,1.775,0,0,0-.336.032,1.694,1.694,0,0,0-.321.1,1.636,1.636,0,0,0-.3.159,1.741,1.741,0,0,0-.26.214,1.663,1.663,0,0,0-.214.261,1.743,1.743,0,0,0-.159.3,1.685,1.685,0,0,0-.1.324A1.649,1.649,0,0,0,26.835,18.727Zm2.454,0a.723.723,0,0,1-.056.282.716.716,0,0,1-.159.238.74.74,0,0,1-.521.217.723.723,0,0,1-.282-.056.7.7,0,0,1-.238-.16.716.716,0,0,1-.159-.238.734.734,0,0,1,0-.565.707.707,0,0,1,.159-.24.744.744,0,0,1,.238-.16.752.752,0,0,1,.282-.056.738.738,0,0,1,.281.056.751.751,0,0,1,.24.16.707.707,0,0,1,.159.24A.718.718,0,0,1,29.289,18.727Zm-5.917.334,4.587-4.6a.48.48,0,0,1,.16-.108.491.491,0,0,1,.188-.038.5.5,0,0,1,.189.038.49.49,0,0,1,.159.108.51.51,0,0,1,.107.159.49.49,0,0,1,.037.188.5.5,0,0,1-.037.188.51.51,0,0,1-.107.159l-4.591,4.6a.481.481,0,0,1-.159.105.47.47,0,0,1-.188.038.5.5,0,0,1-.345-.144.51.51,0,0,1-.107-.159.5.5,0,0,1-.037-.188.49.49,0,0,1,.037-.188A.51.51,0,0,1,23.372,19.062Zm0,0"/>
                  </g>
                </svg>
              </span>
              <span class="nav-label">LE CLUB HORTENSE &amp; PRIVILÈGES</span>
              <span class="nav-chevron" :class="{ 'rotated': clubMenuOpen }">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <polyline points="6 9 12 15 18 9" />
                </svg>
              </span>
            </div>
            <div class="nav-subitems" v-show="clubMenuOpen">
              <a href="#" class="nav-subitem" :class="{ active: activeTab === 'club-statut' }"
                @click.prevent="setTab('club-statut')">Statut &amp; privilèges</a>
              <a href="#" class="nav-subitem" :class="{ active: activeTab === 'club-offres' }"
                @click.prevent="setTab('club-offres')">Offres du moment</a>
            </div>
          </div>

          <!-- PARRAINER UN PROCHE -->
          <div class="nav-item" :class="{ active: activeTab === 'sponsorship' }" @click="setTab('sponsorship')">
            <div class="nav-item-header">
              <span class="nav-icon">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="19" height="18" viewBox="0 0 24.625 24.332">
                  <defs>
                    <clipPath id="clip-path-sponsorship">
                      <path id="Tracé_44" data-name="Tracé 44" d="M13.426,13.82H38.051V38.152H13.426Zm0,0" transform="translate(0 0)"/>
                    </clipPath>
                  </defs>
                  <g id="_5" data-name="5" transform="translate(-13.426 -13.82)" clip-path="url(#clip-path-sponsorship)" fill="none" stroke="currentColor" stroke-width="1.8">
                    <path id="Tracé_43" data-name="Tracé 43" d="M28.068,28.073a.031.031,0,0,0-.038.024.031.031,0,0,0,0,.017,4.842,4.842,0,0,1-.521,3.851,5.636,5.636,0,0,1-.869,1.1c-1.15,1.1-2.29,2.151-3.751,3.532a5.606,5.606,0,0,1-9.373-2.936,5.269,5.269,0,0,1,.428-3.231,6.637,6.637,0,0,1,.835-1.313,12.157,12.157,0,0,1,1.075-1.122q1.873-1.791,3.2-3.041a4.9,4.9,0,0,1,3.831-1.376,4.3,4.3,0,0,1,.713.111.04.04,0,0,0,.049-.031.057.057,0,0,0,0-.017,5.392,5.392,0,0,1,1.847-5.031q2.373-2.231,3.667-3.481a3.992,3.992,0,0,1,.9-.615,5.411,5.411,0,0,1,7.984,5.121,5.256,5.256,0,0,1-.386,1.794,7.129,7.129,0,0,1-.8,1.373,9.61,9.61,0,0,1-1.09,1.151Q33.283,26.292,33,26.567a6.413,6.413,0,0,1-1.136.922A5.138,5.138,0,0,1,28.068,28.073Zm.04-.725a4.221,4.221,0,0,0,3.848-.753q.2-.153.515-.453,2.725-2.577,3.237-3.07a5.24,5.24,0,0,0,1.651-3.42,4.741,4.741,0,0,0-7.12-4.466,6,6,0,0,0-1.057.844q-1.569,1.5-3.44,3.28a5.172,5.172,0,0,0-1.1,1.525,4.4,4.4,0,0,0,.614,4.668.055.055,0,0,0,.076.008l0,0,1.278-1.223a.024.024,0,0,0,0-.032,2.452,2.452,0,0,1-.1-3,3.708,3.708,0,0,1,.589-.661q2.086-1.963,3.235-3.058a5.408,5.408,0,0,1,.992-.794,2.913,2.913,0,0,1,4.052,1.391,2.989,2.989,0,0,1-.4,3.022,6.685,6.685,0,0,1-.566.583q-2.031,1.931-3.316,3.136a2.789,2.789,0,0,1-1.461.792.128.128,0,0,0-.093.064,2.992,2.992,0,0,1-.5.657q-.882.847-.948.913a.028.028,0,0,0,0,.041A.021.021,0,0,0,28.107,27.347Zm-1.249-5.4a1.709,1.709,0,0,0,.275-.07A2.281,2.281,0,0,1,30,23.707a3.425,3.425,0,0,1-.044,1.142.036.036,0,0,0,.029.043.038.038,0,0,0,.026,0,2.921,2.921,0,0,0,.505-.382q2.137-2.025,3.516-3.313a3.33,3.33,0,0,0,.582-.663,2.277,2.277,0,0,0-1.269-3.374,2.221,2.221,0,0,0-1.7.176,1.377,1.377,0,0,0-.339.226q-2.219,2.086-4.035,3.8a2.443,2.443,0,0,0-.434.548.025.025,0,0,0,.011.034A.021.021,0,0,0,26.858,21.947Zm-.125.9a2.12,2.12,0,0,0,.272.808.065.065,0,0,0,.06.034c.305-.011.449.136.434.441a.6.6,0,0,1-.171.418q-1.379,1.308-3.022,2.86c-.257.244-.892.374-.832-.189a.1.1,0,0,0-.047-.1,2.056,2.056,0,0,0-.837-.318.117.117,0,0,0-.118.061,1.775,1.775,0,0,0,.84,2.6,2.11,2.11,0,0,0,1.762-.3,4.8,4.8,0,0,0,.707-.6q1.163-1.12,2.522-2.393a3.856,3.856,0,0,0,.646-.719,2.025,2.025,0,0,0-.024-2.419,1.612,1.612,0,0,0-2.164-.246A.064.064,0,0,0,26.733,22.846Zm.573,5.274a.049.049,0,0,0-.063-.029.063.063,0,0,0-.017.011l-1.49,1.426a.1.1,0,0,0-.029.055,2.645,2.645,0,0,1-.826,1.591q-.9.834-1.466,1.373-.27.261-1.971,1.869a5.348,5.348,0,0,1-1.032.823c-2.539,1.3-5.489-1.394-4.045-4a2.846,2.846,0,0,1,.457-.649q.8-.763,3.753-3.542a3.98,3.98,0,0,1,.977-.736A2.251,2.251,0,0,1,24,26.718a.046.046,0,0,0,.06,0l.689-.661a.054.054,0,0,0,.006-.072,5.735,5.735,0,0,1-.817-1.4.177.177,0,0,0-.1-.1,4.011,4.011,0,0,0-3.211.179,4.48,4.48,0,0,0-.876.566c-.029.031-.282.269-.757.715q-1.667,1.562-2.953,2.811a7.682,7.682,0,0,0-.939,1.049,5.9,5.9,0,0,0-.673,1.235,4.645,4.645,0,0,0,.562,4.35,4.912,4.912,0,0,0,7.337.794q.518-.458,3.492-3.274a6.864,6.864,0,0,0,.878-.942,5.326,5.326,0,0,0,.628-1.124A3.848,3.848,0,0,0,27.306,28.12Zm-2.438,1.916a2.4,2.4,0,0,1-3.153-1.225,2.431,2.431,0,0,1-.061-1.738.027.027,0,0,0-.017-.034.03.03,0,0,0-.023,0,3.593,3.593,0,0,0-.42.336q-.808.737-3.764,3.555a2.321,2.321,0,0,0-.753,1.96,2.46,2.46,0,0,0,1.11,1.66,2.249,2.249,0,0,0,2.6-.1,9.836,9.836,0,0,0,.907-.815q.479-.463.884-.837c.646-.6.937-.893,1.591-1.5A6.386,6.386,0,0,0,24.9,30.074a.028.028,0,0,0-.008-.037A.028.028,0,0,0,24.867,30.036Zm0,0" transform="translate(0.001 -0.008)" fill="#131313"/>
                  </g>
                </svg>

              </span>
              <span class="nav-label">PARRAINER UN PROCHE</span>
            </div>
          </div>

          <!-- SE DÉCONNECTER -->
          <div class="nav-item nav-logout">
            <a href="/users/sign_out" data-method="delete" class="nav-item-header nav-link-external">
              <span class="nav-icon">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="18" height="18" viewBox="0 0 25.859 25.913">
                  <defs>
                    <clipPath id="clip-path-logout">
                      <path id="Tracé_46" data-name="Tracé 46" d="M14.59,17.1H33.925V43.011H14.59Zm0,0" transform="translate(-14.59 -17.098)"/>
                    </clipPath>
                  </defs>
                  <g id="Pictos_-_Espace_client_Hortense" data-name="Pictos - Espace client Hortense" transform="translate(-14.59 -17.098)">
                    <g id="Groupe_11" data-name="Groupe 11" transform="translate(14.59 17.098)" clip-path="url(#clip-path-logout)">
                      <path id="Tracé_45" data-name="Tracé 45" d="M16.015,41.444a4.728,4.728,0,0,0,1.35.89,4.673,4.673,0,0,0,1.57.379c1.857.135,3.75.2,5.627.2,1.952,0,2.946-.073,4.744-.2a4.437,4.437,0,0,0,1.554-.352,4.274,4.274,0,0,0,.7-.379,4.346,4.346,0,0,0,.626-.5,4.586,4.586,0,0,0,.523-.6,4.348,4.348,0,0,0,.4-.689,4.4,4.4,0,0,0,.275-.75,4.453,4.453,0,0,0,.137-.788c.044-1,.088-2.008.124-3.06V34.115a.66.66,0,0,0-.051-.252.609.609,0,0,0-.142-.213.646.646,0,0,0-.467-.193.665.665,0,0,0-.252.049.678.678,0,0,0-.213.144.609.609,0,0,0-.142.213.627.627,0,0,0-.051.252v1.454c-.035,1.025-.078,2.034-.122,3.02a2.989,2.989,0,0,1-.1.551,3.131,3.131,0,0,1-.2.523,3.2,3.2,0,0,1-.292.48,3.268,3.268,0,0,1-.374.419,3.226,3.226,0,0,1-.441.345,3.073,3.073,0,0,1-.5.259,3.042,3.042,0,0,1-.536.166,2.992,2.992,0,0,1-.556.067c-1.771.129-2.749.2-4.651.2-1.846,0-3.706-.067-5.534-.2a3.278,3.278,0,0,1-2.1-.906,2.83,2.83,0,0,1-.881-1.9c-.142-2.77-.212-5.672-.212-8.629s.069-5.867.212-8.638a2.961,2.961,0,0,1,.1-.551,3.185,3.185,0,0,1,.2-.523,3.119,3.119,0,0,1,.29-.478,3.036,3.036,0,0,1,.812-.764,3.2,3.2,0,0,1,.494-.261,3.236,3.236,0,0,1,.534-.166,3.157,3.157,0,0,1,.554-.069c1.749-.126,3.609-.192,5.535-.192s2.922.066,4.654.192a3.3,3.3,0,0,1,2.108.908,2.8,2.8,0,0,1,.627.865,2.845,2.845,0,0,1,.261,1.036c.027.609.053,1.558.078,2.435l.044,2.043a.654.654,0,0,0,.192.465.666.666,0,0,0,.215.144.668.668,0,0,0,.5,0,.678.678,0,0,0,.213-.144.646.646,0,0,0,.193-.465l-.044-2.081c-.024-.885-.051-1.844-.078-2.459a4.148,4.148,0,0,0-1.291-2.79A4.707,4.707,0,0,0,29.307,17.2c-1.758-.129-2.772-.2-4.744-.2-1.953,0-3.847.066-5.623.2a4.46,4.46,0,0,0-.792.1,4.55,4.55,0,0,0-.759.246,4.434,4.434,0,0,0-.7.379,4.567,4.567,0,0,0-.624.5,4.441,4.441,0,0,0-.522.6,4.372,4.372,0,0,0-.68,1.439,4.244,4.244,0,0,0-.135.786c-.142,2.792-.213,5.716-.213,8.7s.071,5.9.213,8.7a4.052,4.052,0,0,0,.378,1.517A4.11,4.11,0,0,0,16.015,41.444Zm0,0" transform="translate(-14.548 -17.048)"/>
                    </g>
                    <path id="Tracé_47" data-name="Tracé 47" d="M44.644,42.941a.66.66,0,0,0-.164.2.614.614,0,0,0-.075.246.679.679,0,0,0,.024.257.634.634,0,0,0,.122.226.643.643,0,0,0,.2.164.656.656,0,0,0,.5.049.642.642,0,0,0,.228-.122,23.409,23.409,0,0,0,3.91-3.912.837.837,0,0,0,.064-.111.667.667,0,0,0,.033-.062.569.569,0,0,0-.033-.544.858.858,0,0,0-.064-.113,23.409,23.409,0,0,0-3.91-3.912A.67.67,0,0,0,45,35.16a.645.645,0,0,0-.246.075.654.654,0,0,0-.2.162.668.668,0,0,0-.12.228.633.633,0,0,0-.026.255.678.678,0,0,0,.075.246.689.689,0,0,0,.164.2,22.35,22.35,0,0,1,2.816,2.648H32.291a.634.634,0,0,0-.252.051.654.654,0,0,0-.356.356.634.634,0,0,0-.051.252.658.658,0,0,0,.407.609.634.634,0,0,0,.252.051H47.46A22.351,22.351,0,0,1,44.644,42.941Zm0,0" transform="translate(-9.086 -9.627)"/>
                  </g>
                </svg>

              </span>
              <span class="nav-label">SE DÉCONNECTER</span>
            </a>
          </div>
        </nav>
      </aside>

      <!-- RIGHT CONTENT AREA -->
      <div class="dashboard-content">

        <!-- ===== MON PROFIL - INFO & ADRESSES ===== -->
        <div v-if="activeTab === 'profil-info' || activeTab === 'profil-password'" class="content-section">
          <h1 class="content-title">Mon profil</h1>

          <!-- Info Card -->
          <div class="info-card">
            <div class="info-card-header">
              <span class="info-card-title">MES INFORMATIONS &amp; ADRESSES</span>
              <button class="edit-link" @click="editingInfo = !editingInfo">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z" />
                </svg>
                Modifier
              </button>
            </div>

            <div class="info-form-grid">
              <!-- First/Last Name -->
              <div class="form-group">
                <label>Prénom</label>
                <input v-model="userInfo.first_name" type="text" :disabled="!editingInfo"
                  :class="{ editable: editingInfo }">
              </div>
              <div class="form-group">
                <label>Nom</label>
                <input v-model="userInfo.last_name" type="text" :disabled="!editingInfo"
                  :class="{ editable: editingInfo }">
              </div>
              <!-- Email / Phone -->
              <div class="form-group">
                <label>Email</label>
                <input v-model="userInfo.email" type="text" :disabled="!editingInfo" :class="{ editable: editingInfo }">
              </div>
              <div class="form-group">
                <label>Numéro de téléphone</label>
                <input v-model="userInfo.phone" type="text" :disabled="!editingInfo" :class="{ editable: editingInfo }">
              </div>
              <div class="form-group full-width">
                <label>Date de naissance</label>
                <input v-model="userInfo.birthday" type="date" :disabled="!editingInfo" :class="{ editable: editingInfo }">
                <small class="birthday-help-text">Si vous renseignez votre date de naissance, vous recevrez une surprise pour votre anniversaire.</small>
              </div>
              <!-- Address full width -->
              <div class="form-group full-width">
                <label>Adresse</label>
                <input v-model="userInfo.address" type="text" :disabled="!editingInfo"
                  :class="{ editable: editingInfo }">
              </div>
              <!-- Ville / Code postal -->
              <div class="form-group">
                <label>Ville</label>
                <input v-model="userInfo.city" type="text" :disabled="!editingInfo" :class="{ editable: editingInfo }">
              </div>
              <div class="form-group">
                <label>Code postal</label>
                <input v-model="userInfo.postal_code" type="text" :disabled="!editingInfo"
                  :class="{ editable: editingInfo }">
              </div>
            </div>

            <div v-if="editingInfo" class="form-actions">
              <button @click="saveProfileAndAddress" class="btn-primary-dashboard">Enregistrer</button>
              <button @click="editingInfo = false" class="btn-secondary-dashboard">Annuler</button>
            </div>
          </div>

          <!-- Password Card - Always visible when in profil section -->
          <div class="info-card">
            <div class="info-card-header">
              <span class="info-card-title">MON MOT DE PASSE</span>
              <a href="#" class="reset-link" @click.prevent="setTab('profil-password')">Réinitialiser mon mot de
                passe</a>
            </div>
            <!-- Password form shown when activeTab is 'profil-password' -->
            <div v-if="activeTab === 'profil-password'" class="info-form-grid">
              <div class="form-group full-width">
                <label>Ancien mot de passe</label>
                <input v-model="userInfo.password" type="password" autocomplete="new-password" class="editable">
              </div>
              <div class="form-group full-width">
                <label>Nouveau mot de passe</label>
                <input v-model="userInfo.new_password" type="password" class="editable">
              </div>
              <div class="form-group full-width">
                <label>Confirmation du nouveau mot de passe</label>
                <input v-model="userInfo.password_confirmation" type="password" class="editable">
              </div>
            </div>
            <div v-if="activeTab === 'profil-password'" class="form-actions">
              <button @click="editUserpassword" class="btn-primary-dashboard">SAUVEGARDER LE MOT DE PASSE</button>
            </div>
          </div>
        </div>

        <!-- ===== MES RÉSERVATIONS ===== -->
        <div v-if="activeTab === 'reservations'" class="content-section">
          <h1 class="content-title">Mes Réservations</h1>

          <!-- Loader -->
          <Loader v-if="loadingReservations" text="Chargement de vos réservations..." />

          <!-- Filter tabs -->
          <div v-if="!loadingReservations" class="resa-filters">
            <a href="#" :class="{ 'filter-link': true, 'active-filter': resaFilter === 'all' }"
              @click.prevent="resaFilter = 'all'">
              Tous ({{ reservationsList.length }})
            </a>
            <span class="filter-sep">|</span>
            <a href="#" :class="{ 'filter-link': true, 'active-filter': resaFilter === 'upcoming' }"
              @click.prevent="resaFilter = 'upcoming'">
              À venir ({{ pendings ? pendings.length : 0 }})
            </a>
            <span class="filter-sep">|</span>
            <a href="#" :class="{ 'filter-link': true, 'active-filter': resaFilter === 'past' }"
              @click.prevent="resaFilter = 'past'">
              Passées ({{ pasts ? pasts.length : 0 }})
            </a>
            <span class="filter-sep">|</span>
            <a href="#" :class="{ 'filter-link': true, 'active-filter': resaFilter === 'cancelled' }"
              @click.prevent="resaFilter = 'cancelled'">
              Annulées ({{ cancelled ? cancelled.length : 0 }})
            </a>
          </div>

          <!-- Empty state -->
          <div v-if="!loadingReservations && filteredReservations.length === 0" class="empty-state">
            <p>Vous n'avez aucune réservation pour le moment.</p>
            <a href="/reservation-hotel" style="width: max-content;" class="hortense-btn-primary">Réservez un séjour</a>
          </div>

          <!-- Reservation cards -->
          <div v-if="!loadingReservations" :class="upcomingConfirmedReservation ? 'resa-cards-grid' : ''">
            <div v-for="resa in filteredReservations" :key="resa.id" class="resa-card">
              <div class="resa-card-image" @click="redirectTo(`/reservation-hotel/${resa.lodging.slug}`)" style="cursor: pointer;">
                <img :src="resaImage(resa)" :alt="resa.lodging && resa.lodging.name">
              </div>
              <div class="resa-card-body">
                <div class="w-100 d-flex justify-content-between" :class="isPhone ? 'flex-column' : ''">
                  <div class="d-flex flex-column">
                    <div class="resa-name-row">
                      <span class="resa-name merriweather-reg-15">{{ resa.lodging && resa.lodging.name }}</span>
                      <span class="resa-badge" :class="resaBadgeClass(resa)">{{ resaBadgeLabel(resa) }}</span>
                    </div>
                    <p class="resa-address raleway-reg-p15">{{ resa.lodging && resa.lodging.full_address }}</p>
                  </div>
                  <div class="resa-card-price">
                    <span class="resa-price">{{ resa.total ? resa.total.toFixed(0) + ' EUR' : '—' }}</span>
                    <span class="resa-price-label">Total séjour</span>
                  </div>
                </div>
                <div class="resa-card-bottom">
                  <p class="resa-dates raleway-reg-p15">{{ formatResaDate(resa.checkin) }} - {{
                    formatResaDate(resa.check_out) }}</p>
                  <div class="resa-card-actions">
                    <a href="#" class="resa-action-link" @click.prevent="showResaDetails(resa)">Détails</a>
                    <a v-if="!resa.cancel && isUpcoming(resa)" href="#" class="resa-action-link"
                      @click.prevent="cancelReservation(resa)">Annuler</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- ===== MA WISHLIST ===== -->
        <div v-if="activeTab === 'wishlist'" class="content-section"
          :class="!wishList.lodgings || wishList.lodgings.length === 0 ? 'w-100' : ''">
          <h1 class="content-title">Ma wishlist</h1>
          <!-- Lodgings wishlist -->
          <div>
            <div v-if="!wishList.lodgings || wishList.lodgings.length === 0" class="empty-state mx-auto">
              <p>Vous n’avez aucun hébergement dans vos favoris pour le moment.</p>
              <a href="/reservation-hotel" style="width: max-content;" class="hortense-btn-primary">Trouvez mon premier coup de cœur</a>
            </div>
            <div v-for="lodging in wishList.lodgings" :key="lodging.id" class="wish-card">
              <div class="wish-card-image" @click="redirectTo(`/reservation-hotel/${lodging.slug}`)" style="cursor: pointer;">
                <img
                  :src="lodging.photo_banner || 'https://images.unsplash.com/photo-1566073771259-6a8506099945?auto=format&fit=crop&w=200&q=80'"
                  :alt="lodging.name">
              </div>
              <div class="wish-card-body">
                <!-- Header with name and wishlist icon -->
                <div class="wish-header">
                  <div class="wish-name-row">
                    <span class="wish-name merriweather-reg-15 cursor-pointer"
                      @click="redirectTo(`/reservation-hotel/${lodging.slug}`)">{{ lodging.name }}</span>
                    <span class="wish-stars" v-if="lodging.standing && parseInt(lodging.standing) > 0">
                      <img src="../../images/Etoiles.svg" v-if="lodging.standing"
                        v-for="i in Math.max(0, parseInt(lodging.standing) || 0)" :key="i" />
                      <img v-if="lodging.standing && parseInt(lodging.standing) > 0" src="../../images/blanc.png"
                        alt="white" />
                    </span>
                  </div>
                  <button class="wish-heart-btn" @click="toggleLike(lodging.id)" title="Retirer des favoris">
                    <i class="fa-solid fa-heart" style="color: rgb(213, 106, 112);"></i>
                  </button>
                </div>

                <!-- Hotel type badge -->
                <div class="d-flex align-items-center" :class="isPhone ? 'flex-wrap' : ''">
                  <div class="wish-type-badge raleway-semi-p11 text-uppercase">
                    {{ getTypeLabel(lodging.type) }}
                  </div>
                  <span class="wish-location raleway-reg-p15 ml-1" v-if="lodging.full_address"> • {{ lodging.full_address
                    }}</span><a href="#" class="wish-map-link raleway-semi-p15 mb-2 ml-2" :class="isPhone ? 'w-100 ml-0' : ''" @click.prevent="displayWishlistMap(lodging)">voir sur la carte</a>
                </div>
                <!-- Discount Badges -->
                <div class="wish-badges-container mb-0"
                  v-if="lodging.lodging_discounts && lodging.lodging_discounts.length > 0">
                  <CardDiscountBadges :lodging="lodging" />
                </div>
                <!-- Ratings -->
                <div class="wish-ratings" v-if="lodging.ratings && lodging.ratings.length > 0">
                  <i class="fa-solid fa-star ta-starr" style="font-size: 13px;"></i>
                  <span class="raleway-semi-p13">{{ lodging.lodging_description &&
                    lodging.lodging_description.rating_value ? lodging.lodging_description.rating_value :
                    calculateAverage(lodging.ratings) }}/5</span>
                  <a :href="'/reservation-hotel/' + lodging.slug + '/avis'" target="_blank" class="link-hortense raleway-semi-p13">{{
                    lodging.ratings.length }} avis</a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Map Modal for Wishlist -->
        <portal to="modals">
          <Maplodgingshow v-if="showWishlistMap" :selected-lodging="selectedWishlistLodging" :nearby-lodgings="wishlistNearbyLodgings" @close="showWishlistMap = false"></Maplodgingshow>
        </portal>

        <!-- ===== LE CLUB HORTENSE - STATUT & PRIVILÈGES ===== -->
        <div v-if="activeTab === null || activeTab === 'club-statut' || activeTab === 'club-offres'" class="content-section w-100">
          <!-- Welcome Banner (shown only when activeTab === null) -->
          <div v-if="activeTab === null" class="club-welcome-banner">
            <div class="banner-content">
              <p class="banner-greeting">Bonjour {{ userInfo.first_name }},</p>
              <p class="banner-title">Bienvenue dans votre espace Club Hortense</p>
            </div>
          </div>

          <!-- VOTRE STATUT -->
          <div class="club-block" :class="activeTab == null ? 'with-box-shadow' : ''">
            <h3 class="club-block-title text-uppercase">Votre statut Club Hortense</h3>
            <p class="raleway-reg-p15">Plus vous réservez sur Hortense, plus vous cumulez de points et débloquez des privilèges. Cumulables, ces privilèges vous offrent la possibilité de profiter jusqu’à 4 avantages exclusifs lors d’un même séjour.</p>
            <p class="club-status-hint raleway-reg-p15">
              Plus que <span class="raleway-medi-p15">{{ pointsToNextLevel }} points</span> pour atteindre le statut <span class="raleway-medi-p15">{{
                nextLevelName }}</span>.
            </p>

            <!-- Loyalty gauge -->
            <div class="loyalty-gauge-container">
              <!-- Gauge grid -->
              <div class="gauge-scroll-wrapper">
                <div class="scroll-inner" :class="userInfo.loyalty_points < 300 ? 'left-offset-margin' : ''">
                  <div class="gauge-grid">
                    <!-- Single continuous progress track -->
                    <div class="gauge-track">
                      <!-- Floating bubble (inside track for aligned positioning) -->
                      <div class="gauge-status-indicator" :style="clubGaugeStyle">
                        <div class="bubble-content">
                          <span class="bubble-label">{{ currentLevelName }}</span>
                          <span class="bubble-val">{{ userInfo.loyalty_points || 0 }} points</span>
                        </div>
                        <div class="bubble-arrow"></div>
                      </div>
                      <div class="gauge-progress" :style="{ width: `${gaugeProgressPercent}%` }"></div>
                      <!-- Checkpoints at 12.5%, 37.5%, 62.5%, 87.5% (center of each section) -->
                      <div class="gauge-checkpoint" style="left: 12.5%">
                        <i :class="(userInfo.loyalty_points || 0) >= 500 ? 'fas fa-check' : 'fas fa-lock'"></i>
                      </div>
                      <div class="gauge-checkpoint" style="left: 37.5%">
                        <i :class="(userInfo.loyalty_points || 0) >= 1000 ? 'fas fa-check' : 'fas fa-lock'"></i>
                      </div>
                      <div class="gauge-checkpoint" style="left: 62.5%">
                        <i :class="(userInfo.loyalty_points || 0) >= 1500 ? 'fas fa-check' : 'fas fa-lock'"></i>
                      </div>
                      <div class="gauge-checkpoint" style="left: 87.5%">
                        <i :class="(userInfo.loyalty_points || 0) >= 2500 ? 'fas fa-check' : 'fas fa-lock'"></i>
                      </div>
                    </div>

                    <!-- Labels row (4 columns) -->
                    <div class="gauge-labels-row">
                      <div class="gauge-section-label">
                        <div class="guage-label text-uppercase pt-3 text-center">1 AVANTAGE EXCLUSIF</div>
                        <div class="guage-sub-label pt-1">GREEN TROTTER</div>
                        <div class="gauge-sub-label pt-1">500 POINTS</div>
                        <p class="small">10 nuits réservées sur Hortense</p>
                      </div>
                      <div class="gauge-section-label">
                        <div class="guage-label text-uppercase pt-3 text-center">2 AVANTAGES EXCLUSIFS</div>
                        <div class="guage-sub-label pt-1">GREEN TROTTER PLUS</div>
                        <div class="gauge-sub-label pt-1">1000 POINTS</div>
                        <p class="small">20 nuits réservées sur Hortense</p>
                      </div>
                      <div class="gauge-section-label">
                        <div class="guage-label text-uppercase pt-3 text-center">3 AVANTAGES EXCLUSIFS</div>
                        <div class="guage-sub-label pt-1">GREEN TROTTER PREMIUM</div>
                        <div class="gauge-sub-label pt-1">1500 POINTS</div>
                        <p class="small">30 nuits réservées sur Hortense</p>
                      </div>
                      <div class="gauge-section-label">
                        <div class="guage-label text-uppercase pt-3 text-center">4 AVANTAGES EXCLUSIFS</div>
                        <div class="guage-sub-label pt-1">GREEN TROTTER INFINITE</div>
                        <div class="gauge-sub-label pt-1">2500 POINTS</div>
                        <p class="small">50 nuits réservées sur Hortense</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <p class="raleway-reg-p15">Cumulez 50 points à chaque filleul et débloquez de nouveaux privilèges exclusifs. <span class="raleway-semi-p15 text-underline cursor-pointer" @click="activeTab = 'sponsorship'">Parrainez mes proches</span></p>
          </div>

          <!-- VOS PRIVILÈGES EN COURS -->
          <div class="club-block mt-4" :class="activeTab == null ? 'with-box-shadow' : ''">
            <h3 class="club-block-title">VOS PRIVILÈGES</h3>

            <!-- ACTIFS -->
            <div v-if="activePrivileges.length > 0">
              <p class="privilege-section-label">ACTIFS</p>
              <div class="privilege-row" v-for="priv in activePrivileges" :key="priv.key">
                <div class="privilege-row-left">
                  <span class="privilege-code raleway-bold-p">{{ priv.code }}</span>
                  <span class="privilege-desc raleway-reg-p15">{{ priv.desc }}</span>
                </div>
                <div class="privilege-row-right">
                  <span class="privilege-validity raleway-it-l15">{{ priv.validity }}</span>
                </div>
              </div>
            </div>

            <!-- INACTIFS -->
            <div v-if="inactivePrivileges.length > 0" class="mt-3">
              <p class="privilege-section-label privilege-section-label--inactive">INACTIFS</p>
              <div class="privilege-row privilege-row--inactive" v-for="priv in inactivePrivileges" :key="priv.key">
                <div class="privilege-row-left">
                  <span class="privilege-code privilege-code--inactive raleway-bold-p">{{ priv.code }}</span>
                  <span class="privilege-desc privilege-desc--inactive raleway-reg-p15">{{ priv.desc }}</span>
                </div>
                <div class="privilege-row-right">
                  <span class="privilege-validity privilege-validity--inactive raleway-it-l15">{{ priv.validity }}</span>
                </div>
              </div>
            </div>
          </div>

          <!-- User Reservations Section (shown only when activeTab === null) -->
          <div v-if="activeTab === null" class="user-reservations-section" :class="activeTab == null ? 'with-box-shadow' : ''">
            <h3 class="reservations-title">VOS RÉSERVATIONS EN COURS</h3>
            
            <div v-if="loadingReservations" class="reservations-loader">
              <Loader text="Chargement de vos réservations..." />
            </div>

            <div v-else-if="!pendings || pendings.length === 0" class="empty-reservations">
              <p>Vous n'avez aucune réservation en cours.</p>
            </div>

            <div v-else class="reservations-scroll-container">
              <div v-for="resa in pendings" :key="resa.id" class="resa-card">
                <div class="resa-card-image" @click="redirectTo(`/reservation-hotel/${resa.lodging.slug}`)" style="cursor: pointer;">
                  <img :src="resaImage(resa)" :alt="resa.lodging && resa.lodging.name">
                </div>
                <div class="resa-card-body">
                  <div class="w-100 d-flex justify-content-between" :class="isPhone ? 'flex-column' : ''">
                    <div class="d-flex flex-column">
                      <div class="resa-name-row">
                        <span class="resa-name merriweather-reg-15">{{ resa.lodging && resa.lodging.name }}</span>
                        <span class="resa-badge" :class="resaBadgeClass(resa)">{{ resaBadgeLabel(resa) }}</span>
                      </div>
                      <p class="resa-address raleway-reg-p15">{{ resa.lodging && resa.lodging.full_address }}</p>
                    </div>
                    <div class="resa-card-price">
                      <span class="resa-price">{{ resa.total ? resa.total.toFixed(0) + ' EUR' : '—' }}</span>
                      <span class="resa-price-label">Total séjour</span>
                    </div>
                  </div>
                  <div class="resa-card-bottom">
                    <p class="resa-dates raleway-reg-p15">{{ formatResaDate(resa.checkin) }} - {{
                      formatResaDate(resa.check_out) }}</p>
                    <div class="resa-card-actions">
                      <a href="#" class="resa-action-link" @click.prevent="showResaDetails(resa)">Détails</a>
                      <a v-if="!resa.cancel && isUpcoming(resa)" href="#" class="resa-action-link"
                        @click.prevent="cancelReservation(resa)">Annuler</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- ===== PARRAINER UN PROCHE ===== -->
        <MySponsorship v-if="activeTab === 'sponsorship'" :user="userInfo" />

        <!-- ===== CANCELLATION REASON MODAL ===== -->
        <div v-if="showCancelModal" class="modal-overlay" @click.self="showCancelModal = false">
          <div class="modal-box">
            <div class="close-button ml-1" @click="showCancelModal = false">
              <i class="fas fa-times"></i>
            </div>
            <h2 class="modal-title" :class="isPhone ? 'px-4' : ''">Pouvez-vous nous indiquer la raison principale<br>de l'annulation de votre séjour ?
            </h2>
            
            <div class="cancel-reasons-grid">
              <label class="reason-label" v-for="reason in cancelReasons" :key="reason">
                <input type="radio" :value="reason" v-model="selectedReason" class="reason-radio">
                <span>{{ reason }}</span>
              </label>
            </div>
            <textarea v-model="cancellationDetails" class="cancel-textarea" placeholder="Merci de préciser..."
              rows="3"></textarea>
            <!-- Cancellation Conditions Box -->
            <div v-if="pendingCancelResa && pendingCancelResa.cancel_conditions" class="cancellation-conditions-box">
              <h3 class="conditions-title">Conditions d'annulation</h3>
              <p class="conditions-text">{{ pendingCancelResa.cancel_conditions }}</p>
            </div>
            <button class="btn-confirm-cancel" @click="submitCancellation" :disabled="!selectedReason || cancelSubmitting">
              {{ cancelSubmitting ? 'EN COURS...' : 'CONFIRMER MON ANNULATION' }}
            </button>
          </div>
        </div>

        <!-- ===== CANCELLATION SUCCESS MODAL ===== -->
        <div v-if="showCancelSuccess" class="modal-overlay" @click.self="closeCancelSuccess">
          <div class="modal-box modal-box-success">
            <div class="close-button" @click="closeCancelSuccess">
              <i class="fas fa-times"></i>
            </div>
            <div class="success-icon-circle">
              <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#3B6152" stroke-width="2">
                <polyline points="20 6 9 17 4 12" />
              </svg>
            </div>
            <h2 class="modal-title">Confirmation d'annulation</h2>
            <p class="modal-sub">Votre réservation a été annulée, vous recevrez dans quelques instants<br>votre
              confirmation par e-mail.</p>
            <button class="btn-confirm-cancel" @click="closeCancelSuccess">RETOUR À MON ESPACE CLIENT</button>
          </div>
        </div>
      </div>
    </div>
    <!-- ===== NOS OFFRES DU MOMENT (full-width, outside dashboard-layout) ===== -->
    <div v-if="!showDetail && (activeTab === null || activeTab === 'club-statut' || activeTab === 'club-offres')" class="offres-full-section">
      <div class="offres-full-inner">
        <h1 class="offres-title merriweather-reg-24">Nos offres du moment</h1>
        <Loader v-if="loadingOffers" text="Chargement des offres..." />
        <div v-if="!loadingOffers && exclusiveOffers.length === 0" class="empty-state">
          <p>Aucune offre exclusive disponible pour le moment.</p>
        </div>
        <GenericLodgingsDisplay v-if="!loadingOffers && exclusiveOffers.length > 0" :lodgings="exclusiveOffers"
          :user="userInfo" :withDiscountBadges="true" />
      </div>
    </div>

    <!-- ===== RESERVATION EXPERIENCES (full-width, outside dashboard-layout) ===== -->
    <div v-if="!showDetail && activeTab === 'reservations' && upcomingConfirmedReservation" class="reservation-experiences-full-section">
      <div class="reservation-experiences-full-inner">
        <ReservationExperiences
          v-if="!isPhone"
          :upcomingReservation="upcomingConfirmedReservation"
          :user="userInfo"
        />
        <ReservationExperiencesPhone
          v-if="isPhone"
          :upcomingReservation="upcomingConfirmedReservation"
          :user="userInfo"
        />
      </div>
    </div>

    <!-- ===== RESERVATION REVIEW (full-width, outside dashboard-layout) ===== -->
    <ReservationReview
      v-if="!showDetail && activeTab === 'reservations' && pastReservationsForReview.length > 0"
      :reservations="pastReservationsForReview"
      :user="userInfo"
      @review-submitted="onReviewSubmitted"
    />
  </div>
</template>

<script>
import fetcher from 'packs/shared/api.js';
import ReservationDetails from '../../components/reservations/ReservationDetails.vue';
import Loader from '../../components/shared/Loader.vue';
import CardDiscountBadges from '../../components/shared/CardDiscountBadges.vue';
import MySponsorship from './MySponsorship.vue';
import CardPromoCode from './CardPromoCode.vue';
import GenericLodgingsDisplay from '../../components/shared/GenericLodgingsDisplay.vue';
import ReservationExperiences from '../../components/reservations/ReservationExperiences.vue';
import ReservationExperiencesPhone from '../../components/reservations/ReservationExperiencesPhone.vue';
import ReservationReview from '../../components/reservations/ReservationReview.vue';
import Maplodgingshow from '../../pages/lodgings/Maplodgingshow.vue';

export default {
  name: 'registration-user',
  props: {
    user: Object,
    reservations: Array,
    selectedTab: {
      type: String,
      default: null,
    },
  },
  components: {
    ReservationDetails,
    Loader,
    CardDiscountBadges,
    MySponsorship,
    CardPromoCode,
    GenericLodgingsDisplay,
    ReservationExperiences,
    ReservationExperiencesPhone,
    ReservationReview,
    Maplodgingshow,
  },
  data() {
    return {
      isPhone: window.innerWidth <= 768,
      userInfo: { ...this.user },
      selectedResa: null,
      showDetail: false,
      postal_code: '',
      city: '',
      activeTab: null,
      profilMenuOpen: false,
      clubMenuOpen: false,
      editingInfo: false,
      mobileMenuOpen: false,
      isMobile: false,

      // Reservations
      reservationsList: [],
      pendings: null,
      cancelled: null,
      pasts: null,
      resaFilter: 'all',
      loadingReservations: false,

      // Cancellation modal
      showCancelModal: false,
      showCancelSuccess: false,
      pendingCancelResa: null,
      selectedReason: '',
      cancellationDetails: '',
      cancelSubmitting: false,
      cancelReasons: [
        'Changement de dates',
        'Contraintes budgétaires',
        'Séjour reporté',
        'Autre',
        'Séjour annulé définitivement',
        'Réservation effectuée ailleurs',
        'Imprévu personnel',
      ],

      // Wishlist
      wishList: { lodgings: [], experiences: [] },
      wishlistType: 'lodging',
      showWishlistMap: false,
      selectedWishlistLodging: null,
      wishlistNearbyLodgings: [],

      // Club Hortense
      exclusiveOffers: [],
      loadingOffers: false,
      userDiscountCode: null,
      giftCards: [],
      openPrivileges: [false, false, false],

      // Reservation Experiences
      upcomingConfirmedReservation: null,

      // Reservation Review
      pastReservationsForReview: [],
    };
  },
  computed: {
    currentUserIdentifier() {
      // Extract slug from URL path (e.g., /dashboard/aurore-sterling -> aurore-sterling)
      const pathParts = window.location.pathname.split('/');
      const dashboardIndex = pathParts.indexOf('dashboard');
      if (dashboardIndex !== -1 && pathParts[dashboardIndex + 1]) {
        return pathParts[dashboardIndex + 1];
      }
      // Fallback to user slug or ID
      return this.user.slug || this.user.id;
    },
    userInitials() {
      const first = (this.userInfo.first_name || '').charAt(0).toUpperCase();
      const last = (this.userInfo.last_name || '').charAt(0).toUpperCase();
      return first + last || '?';
    },
    pendingCount() {
      return this.pendings ? this.pendings.length : 0;
    },
    wishlistCount() {
      return this.wishList.lodgings ? this.wishList.lodgings.length : 0;
    },
    filteredReservations() {
      if (this.resaFilter === 'upcoming') return this.pendings || [];
      if (this.resaFilter === 'past') return this.pasts || [];
      if (this.resaFilter === 'cancelled') return this.cancelled || [];
      return this.reservationsList;
    },
    // ---- Club Hortense computed ----
    currentLevelName() {
      const pts = this.userInfo.loyalty_points || 0;
      if (pts >= 2500) return 'Green Trotter Infinite';
      if (pts >= 1500) return 'Green Trotter Premium';
      if (pts >= 1000) return 'Green Trotter Plus';
      if (pts >= 500) return 'Green Trotter';
      return 'Membre';
    },
    nextLevelName() {
      const pts = this.userInfo.loyalty_points || 0;
      if (pts >= 2500) return 'Green Trotter Infinite';
      if (pts >= 1500) return 'Green Trotter Infinite';
      if (pts >= 1000) return 'Green Trotter Premium';
      if (pts >= 500) return 'Green Trotter Plus';
      return 'Green Trotter';
    },
    pointsToNextLevel() {
      const pts = this.userInfo.loyalty_points || 0;
      if (pts >= 2500) return 0;
      if (pts >= 1500) return 2500 - pts;
      if (pts >= 1000) return 1500 - pts;
      if (pts >= 500) return 1000 - pts;
      return 500 - pts;
    },
    welcomeCodeStart() {
      if (!this.userInfo.created_at) return '—';
      return new Date(this.userInfo.created_at).toLocaleDateString('fr-FR');
    },
    welcomeCodeEnd() {
      if (!this.userInfo.created_at) return '—';
      const d = new Date(this.userInfo.created_at);
      const createdDate = new Date(this.userInfo.created_at);
      const marchSeventh2026 = new Date(2026, 2, 7); // March 7th, 2026 (Month is 0-indexed)
      
      if (createdDate > marchSeventh2026) {
        // User created after March 7th, 2026: add 1 month
        d.setMonth(d.getMonth() + 1);
      } else {
        // User created on or before March 7th, 2026: add 1 year
        d.setFullYear(d.getFullYear() + 1);
      }
      return d.toLocaleDateString('fr-FR');
    },
    clubGaugeStyle() {
      const pts = this.userInfo.loyalty_points || 0;
      const checkpoints = [500, 1000, 1500, 2500];
      const centers = [12.5, 37.5, 62.5, 87.5];
      const capped = Math.min(pts, 2500);
      let pos = 0;
      if (capped <= checkpoints[0]) {
        pos = (capped / checkpoints[0]) * centers[0];
      } else if (capped <= checkpoints[1]) {
        const p = (capped - checkpoints[0]) / (checkpoints[1] - checkpoints[0]);
        pos = centers[0] + p * (centers[1] - centers[0]);
      } else if (capped <= checkpoints[2]) {
        const p = (capped - checkpoints[1]) / (checkpoints[2] - checkpoints[1]);
        pos = centers[1] + p * (centers[2] - centers[1]);
      } else {
        const p = (capped - checkpoints[2]) / (checkpoints[3] - checkpoints[2]);
        pos = centers[2] + p * (centers[3] - centers[2]);
      }
      return { left: `${pos}%`, transform: 'translateX(-50%)' };
    },
    gaugeProgressPercent() {
      const pts = this.userInfo.loyalty_points || 0;
      const checkpoints = [500, 1000, 1500, 2500];
      const centers = [12.5, 37.5, 62.5, 87.5];
      const capped = Math.min(pts, 2500);
      let pos = 0;
      if (capped <= checkpoints[0]) {
        pos = (capped / checkpoints[0]) * centers[0];
      } else if (capped <= checkpoints[1]) {
        const p = (capped - checkpoints[0]) / (checkpoints[1] - checkpoints[0]);
        pos = centers[0] + p * (centers[1] - centers[0]);
      } else if (capped <= checkpoints[2]) {
        const p = (capped - checkpoints[1]) / (checkpoints[2] - checkpoints[1]);
        pos = centers[1] + p * (centers[2] - centers[1]);
      } else {
        const p = (capped - checkpoints[2]) / (checkpoints[3] - checkpoints[2]);
        pos = centers[2] + p * (centers[3] - centers[2]);
      }
      return pos;
    },
    allPrivileges() {
      const today = new Date();
      const list = [];

      // BIENVENUE
      const bienvenueEnd = (() => {
        if (!this.userInfo.created_at) return null;
        const d = new Date(this.userInfo.created_at);
        const createdDate = new Date(this.userInfo.created_at);
        const marchSeventh2026 = new Date(2026, 2, 7);
        if (createdDate > marchSeventh2026) {
          d.setMonth(d.getMonth() + 1);
        } else {
          d.setFullYear(d.getFullYear() + 1);
        }
        return d;
      })();
      const bienvenueUsed = this.userInfo.is_code_used;
      const bienvenueExpired = bienvenueEnd ? today > bienvenueEnd : false;
      const bienvenueActive = !bienvenueUsed && !bienvenueExpired;
      const bienvenueUsedResa = bienvenueUsed
        ? this.reservationsList.find(r => r.code_name === 'BIENVENUE' && r.discount > 0)
        : null;
      list.push({
        key: 'bienvenue',
        code: 'CODE: BIENVENUE',
        desc: '-10% sur votre premier séjour.',
        active: bienvenueActive,
        validity: bienvenueUsed
          ? `utilisé le ${bienvenueUsedResa?.created_at ? new Date(bienvenueUsedResa.created_at).toLocaleDateString('fr-FR') : '—'}`
          : bienvenueExpired
            ? `expiré le ${bienvenueEnd ? bienvenueEnd.toLocaleDateString('fr-FR') : '—'}`
            : `valable du ${this.welcomeCodeStart} au ${this.welcomeCodeEnd}`,
      });

      // User discount codes
      if (this.userDiscountCode) {
        const expired = this.userDiscountCode.validity_date ? today > new Date(this.userDiscountCode.validity_date) : false;
        const used = !!this.userDiscountCode.used_at;
        list.push({
          key: `discount-${this.userDiscountCode.id}`,
          code: `CODE: ${this.userDiscountCode.discount_code}`,
          desc: `${this.userDiscountCode.discount_amount}${this.userDiscountCode.discount_type === 'percent' ? '%' : '€'} de réduction`,
          active: !expired && !used,
          validity: used
            ? `utilisé le ${new Date(this.userDiscountCode.used_at).toLocaleDateString('fr-FR')}`
            : expired
              ? `expiré le ${new Date(this.userDiscountCode.validity_date).toLocaleDateString('fr-FR')}`
              : `valable du ${this.formatPrivilegeDate(this.userDiscountCode.created_at)} au ${this.formatPrivilegeDate(this.userDiscountCode.validity_date)}`,
        });
      }

      // Gift cards
      this.giftCards.forEach(gc => {
        const expired = gc.validity_date ? today > new Date(gc.validity_date) : false;
        const used = !!gc.use_date;
        list.push({
          key: `giftcard-${gc.id}`,
          code: `CODE: ${gc.activation_code}`,
          desc: `${gc.amount}€ de crédit`,
          active: !expired && !used,
          validity: used
            ? `utilisé le ${new Date(gc.use_date).toLocaleDateString('fr-FR')}`
            : expired
              ? `expiré le ${new Date(gc.validity_date).toLocaleDateString('fr-FR')}`
              : `valable jusqu'au ${this.formatPrivilegeDate(gc.validity_date)}`,
        });
      });

      return list;
    },
    activePrivileges() {
      return this.allPrivileges.filter(p => p.active);
    },
    inactivePrivileges() {
      return this.allPrivileges.filter(p => !p.active);
    },
  },
  methods: {
    // ---- Navigation ----
    redirectTo(path) {
      window.open(path, '_blank');
    },
    setTab(tab) {
      this.activeTab = tab;
      this.mobileMenuOpen = false;
      if (tab === 'reservations' && this.reservationsList.length === 0) {
        this.fetchReservations();
        if (this.pendings && this.pendings.length > 0) {
          this.resaFilter = 'upcoming';
        }
      }
      if (tab === 'wishlist' && this.wishList.lodgings.length === 0) {
        this.fetchWishlist();
      }
      if (tab === 'club-statut' && !this.userDiscountCode) {
        this.fetchUserDiscountCode();
      }
      if (tab === 'club-offres' && this.exclusiveOffers.length === 0) {
        this.fetchExclusiveOffers();
      }
      if (tab === 'club-offres') {
        this.$nextTick(() => {
          this.scrollToOffresSection();
        });
      }
    },
    scrollToOffresSection() {
      const offresSection = document.querySelector('.offres-full-section');
      if (offresSection) {
        offresSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    },
    showResaDetails(resa) {
      this.selectedResa = resa;
      this.showDetail = true;
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    toggleProfilMenu() {
      this.profilMenuOpen = !this.profilMenuOpen;
      if (!this.profilMenuOpen && (this.activeTab === 'profil-info' || this.activeTab === 'profil-password')) {
        // keep current tab
      } else if (this.profilMenuOpen) {
        this.setTab('profil-info');
      }
    },
    toggleClubMenu() {
      this.clubMenuOpen = !this.clubMenuOpen;
      if (!this.clubMenuOpen && (this.activeTab === 'club-statut' || this.activeTab === 'club-offres')) {
        // keep current tab
      } else if (this.clubMenuOpen) {
        this.setTab('club-statut');
      }
    },

    // ---- User Profile ----
    formatDate(date) {
      if (!date) return '';
      const set = new Date(date);
      const getDate = set.getDate().toString().padStart(2, '0');
      const getMonth = (set.getMonth() + 1).toString().padStart(2, '0');
      return `${set.getFullYear()}-${getMonth}-${getDate}`;
    },
    async saveProfileAndAddress() {
      await this.updateUserBasicInfo();
      await this.updateUserAddress();
      this.editingInfo = false;
    },
    async updateUserBasicInfo() {
      try {
        await fetcher.patch('/dashboard/' + this.currentUserIdentifier, {
          user: {
            first_name: this.userInfo.first_name,
            last_name: this.userInfo.last_name,
            gender: this.userInfo.gender,
            phone: this.userInfo.phone,
            birthday: this.formatDate(this.userInfo.birthday),
            email: this.userInfo.email,
          },
        });
      } catch (e) {
        console.error(e);
      }
    },
    async updateUserAddress() {
      try {
        await fetcher.patch('/dashboard/' + this.currentUserIdentifier, {
          user: {
            address: this.userInfo.address,
            city: this.userInfo.city,
            postal_code: this.userInfo.postal_code,
            country: this.userInfo.country,
          },
        });
      } catch (e) {
        console.error(e);
      }
    },
    async editUserpassword() {
      try {
        const response = await fetcher.patch('/dashboard/' + this.currentUserIdentifier, {
          user: {
            password: this.userInfo.password,
            new_password: this.userInfo.new_password,
            password_confirmation: this.userInfo.password_confirmation,
          },
        });
        if (response.status === 200) {
          alert('Mot de passe modifié avec succès');
          this.userInfo.password = '';
          this.userInfo.new_password = '';
          this.userInfo.password_confirmation = '';
        }
      } catch (e) {
        console.error(e);
        alert('Erreur lors de la modification du mot de passe');
      }
    },

    // ---- Reservations ----
    dateNow() {
      const set = new Date();
      const d = set.getDate().toString().padStart(2, '0');
      const m = (set.getMonth() + 1).toString().padStart(2, '0');
      return `${set.getFullYear()}-${m}-${d}`;
    },
    async fetchReservations() {
      try {
        this.loadingReservations = true;
        const response = await fetcher.get(`/reservations?user_id=${this.currentUserIdentifier}`);
        this.reservationsList = response.data;
        await this.categorizeReservations();
      } catch (e) {
        console.error(e);
      } finally {
        this.loadingReservations = false;
      }
    },
    async categorizeReservations() {
      const today = this.dateNow();
      this.pendings = this.reservationsList.filter(r =>
        !r.cancel && (r.checkin >= today || r.check_out > today)
      );
      this.cancelled = this.reservationsList.filter(r => r.cancel === true);
      this.pasts = this.reservationsList.filter(r =>
        !r.cancel && r.check_out < today
      );
      // Update upcoming confirmed reservation for experiences section
      this.upcomingConfirmedReservation = await this.getUpcomingConfirmedReservation();
      // Update past reservation for review section
      this.pastReservationsForReview = await this.getPastReservationForReview();
    },
    isUpcoming(resa) {
      const today = this.dateNow();
      return !resa.cancel && (resa.checkin >= today || resa.check_out > today);
    },
    resaImage(resa) {
      return resa.lodging && resa.lodging.photo_banner
        ? resa.lodging.photo_banner
        : 'https://images.unsplash.com/photo-1566073771259-6a8506099945?auto=format&fit=crop&w=200&q=80';
    },
    resaBadgeClass(resa) {
      if (resa.cancel) return 'badge-cancelled';
      if (resa.confirm !== true) return 'badge-pending';
      const today = this.dateNow();
      if (resa.checkin >= today || resa.check_out > today) return 'badge-upcoming';
      return 'badge-past';
    },
    resaBadgeLabel(resa) {
      if (resa.cancel) return 'ANNULÉE';
      if (resa.confirm !== true) return 'EN ATTENTE';
      const today = this.dateNow();
      if (resa.checkin >= today || resa.check_out > today) return 'À VENIR';
      return 'PASSÉE';
    },
    formatResaDate(dateStr) {
      if (!dateStr) return '';
      const months = ['janv.', 'févr.', 'mars', 'avr.', 'mai', 'juin', 'juil.', 'août', 'sept.', 'oct.', 'nov.', 'déc.'];
      const d = new Date(dateStr);
      return `${d.getDate()} ${months[d.getMonth()]} ${d.getFullYear()}`;
    },
    async cancelReservation(resa) {
      this.pendingCancelResa = resa;
      this.selectedReason = '';
      this.cancellationDetails = '';
      this.showCancelModal = true;
    },
    async submitCancellation() {
      if (!this.pendingCancelResa) return;
      this.cancelSubmitting = true;
      try {
        const payload = {
          from_dashboard: true,
          cancellation_reason: this.selectedReason,
          cancellation_details: this.cancellationDetails,
        };
        await fetcher.post(`/reservations/${this.pendingCancelResa.id}/cancel`, payload);
        this.showCancelModal = false;
        this.showCancelSuccess = true;
        await this.fetchReservations();
        this.resaFilter = 'cancelled';
      } catch (e) {
        console.error(e);
        alert(e.response?.data?.error || 'Erreur lors de l\'annulation');
      } finally {
        this.cancelSubmitting = false;
      }
    },
    closeCancelSuccess() {
      this.showCancelSuccess = false;
      this.pendingCancelResa = null;
    },

    // ---- Wishlist ----
    async fetchWishlist() {
      try {
        const response = await fetcher.get(`/wishlists/${this.currentUserIdentifier}.json`);
        this.wishList = response.data;
      } catch (e) {
        console.error(e);
      }
    },
    async toggleLike(id) {
      try {
        const response = await fetcher.patch('/wishlists/' + this.currentUserIdentifier, { lodging_id: id });
        this.wishList = response.data;
      } catch (e) {
        console.error(e);
      }
    },
    async toggleLikeExp(id) {
      try {
        const response = await fetcher.patch('/wishlists/' + this.currentUserIdentifier, { experience_id: id });
        this.wishList = response.data;
      } catch (e) {
        console.error(e);
      }
    },
    lodgingLocation(lodging) {
      const parts = [
        lodging.city && lodging.city.name,
        lodging.department && lodging.department.name,
        lodging.region && lodging.region.name,
      ].filter(Boolean);
      return parts.join(', ');
    },
    getTypeLabel(type) {
      const typeLabels = {
        'Hotel': 'Hôtels',
        'Maison et Villa': 'Maisons et Villas',
        'Guestroom': 'Chambres d\'Hôtes',
        'Lodge': 'Lodges et Lieux Insolites',
        'Appartment': 'Appartements',
        'Chalet': 'Chalets'
      };
      return typeLabels[type] || 'Lodges et lieux insolites';
    },
    calculateAverage(ratings) {
      if (!ratings || ratings.length === 0) return '-';
      const sum = ratings.reduce((acc, rating) => acc + (rating.rate_average || 0), 0);
      return (sum / ratings.length).toFixed(1);
    },
    async displayWishlistMap(lodging) {
      this.selectedWishlistLodging = lodging;
      try {
        const response = await fetcher.get(`/lodgings/${lodging.id}/nearby`);
        this.wishlistNearbyLodgings = response.data.nearby || [];
      } catch (e) {
        console.error('Error fetching nearby lodgings:', e);
        this.wishlistNearbyLodgings = [];
      }
      this.showWishlistMap = true;
    },

    // ---- Club Hortense ----
    async fetchExclusiveOffers() {
      try {
        this.loadingOffers = true;
        const response = await fetcher.get('/offres-exclusives-hortense.json');
        this.exclusiveOffers = response.data.exclusive_lodgings || response.data || [];
      } catch (e) {
        console.error(e);
        this.exclusiveOffers = [];
      } finally {
        this.loadingOffers = false;
      }
    },
    async fetchUserDiscountCode() {
      try {
        const res = await fetcher.get('/dashboard/' + this.user.slug);
        const codes = res.data.user_discount_codes || [];
        this.userDiscountCode = codes.length > 0 ? codes[0] : null;
        this.giftCards = res.data.gift_cards || [];
      } catch (e) {
        console.error(e);
      }
    },
    togglePrivilege(index) {
      this.$set(this.openPrivileges, index, !this.openPrivileges[index]);
    },
    formatPrivilegeDate(date) {
      if (!date) return '—';
      return new Date(date).toLocaleDateString('fr-FR');
    },

    // ---- Responsive ----
    checkMobile() {
      this.isMobile = window.innerWidth < 768;
      if (!this.isMobile) this.mobileMenuOpen = false;
    },

    // ---- Reservation Experiences ----
    async getUpcomingConfirmedReservation() {
      if (!this.pendings || this.pendings.length === 0) {
        return null;
      }
      // Get the first upcoming confirmed reservation (not cancelled)
      const upcoming = this.pendings.find(r => !r.cancel && r.lodging);
      
      if (!upcoming) {
        return null;
      }

      // Fetch lodging data from the endpoint if reservation exists
      if (upcoming.lodging && upcoming.lodging.slug) {
        try {
          const response = await fetcher.get(`/reservation-hotel/${upcoming.lodging.slug}`);
          if (response.data && response.data.lodging) {
            // Update the reservation with the fetched lodging data
            upcoming.lodging = response.data.lodging;
          }
        } catch (e) {
          console.error('Error fetching lodging data:', e);
          // Continue with existing lodging data if fetch fails
        }
      }

      return upcoming;
    },

    // ---- Reservation Review ----
    async getPastReservationForReview() {
      if (!this.pasts || this.pasts.length === 0) {
        return [];
      }
      // Get all past reservations that haven't been reviewed yet
      const pastNotReviewed = this.pasts.filter(r => !r.cancel && r.lodging && (!r.ratings || r.ratings.length === 0));
      
      return pastNotReviewed;
    },

    onReviewSubmitted() {
      // Refresh reservations to update the review status
      this.fetchReservations();
      // Clear the review form
      this.pastReservationsForReview = [];
    },
  },
  mounted() {
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);
    // Initialize activeTab from selectedTab prop if provided
    if (this.selectedTab) {
      this.activeTab = this.selectedTab;
    }
    // Pre-load reservations if they are passed in as props
    if (this.reservations && this.reservations.length > 0) {
      this.reservationsList = this.reservations;
      this.categorizeReservations();
    }
    this.fetchReservations();
    this.fetchWishlist();
    this.fetchUserDiscountCode();
    this.fetchExclusiveOffers();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobile);
  },
};
</script>

<style scoped lang="scss">
/* ===== RESET & BASE ===== */
#registration-user {
  font-family: 'Raleway', sans-serif;
  min-height: 100vh;

  @media screen and (max-width: 768px) {
    justify-content: start;
  }
}

/* ===== LAYOUT ===== */
.dashboard-layout {
  display: flex;
  min-height: 100vh;
  max-width: 90%;
  width: 90%;
  margin: 0 auto;
  padding: 40px 20px;
  gap: 32px;
  border-bottom: 1px solid #f0efed;
}

/* ===== SIDEBAR ===== */
.sidebar {
  width: 280px;
  flex-shrink: 0;
  background: #fff;
  border-radius: 16px;
  padding: 24px 0;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.07);
  align-self: flex-start;
  position: sticky;
  top: 24px;
}

.sidebar-user-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 0 20px 20px;
  border-bottom: 1px solid #f0efed;
}

.avatar-circle {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: #F5F5F5;
  color: #000;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 15px;
  flex-shrink: 0;
  letter-spacing: 0.5px;
  border: 1px solid #E5DFDF;
}

.avatar-circle.large {
  width: 48px;
  height: 48px;
  font-size: 16px;
}

.sidebar-user-details {
  overflow: hidden;
}

.sidebar-greeting {
  color: #1a1a1a;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.sidebar-level {
  color: #3B6152;
  margin: 2px 0 0;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* ===== NAV ITEMS ===== */
.sidebar-nav {
  padding-top: 8px;
}

.nav-item {
  border-bottom: 1px solid #f5f4f2;
  cursor: pointer;
}

.nav-item:last-child {
  border-bottom: none;
}

.nav-item-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px 20px;
  text-decoration: none;
  color: #2d2d2d;
  transition: background 0.18s;
}


.nav-link-external {
  width: 100%;
}

.nav-icon {
  color: #000;
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.nav-label {
  flex: 1;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.6px;
  text-transform: uppercase;
  color: #2d2d2d;
}

.nav-logout .nav-label {
  color: #2d2d2d;
}

.nav-chevron {
  color: #999;
  display: flex;
  align-items: center;
  transition: transform 0.2s;
}

.nav-chevron.rotated {
  transform: rotate(180deg);
}

.pending-badge {
  background: #D56A70;
  color: #fff;
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.5px;
  padding: 3px 8px;
  border-radius: 99px;
  margin-left: 4px;
}

.wishlist-badge {
  background: #BFBFBF;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.5px;
  padding: 3px 13px;
  border-radius: 20px;
  margin-left: 4px;
}

.nav-subitems {
  padding: 4px 0 8px;
}

.nav-subitem {
  display: block;
  padding: 5px 20px 5px 48px;
  font-size: 13px;
  color: #000;
  text-decoration: none;
  transition: color 0.15s;
}

.nav-subitem:hover,
.nav-subitem.active {
  color: #3B6152;
  font-weight: 600;
}

/* ===== RIGHT CONTENT ===== */
.dashboard-content {
  flex: 1;
  min-width: 0;
}

@media (max-width: 767px) {
  .dashboard-layout {
    min-height: fit-content;
  }
}

.content-section {
  animation: fadeIn 0.2s ease;
  @media (max-width: 767px) {
    margin-top: 20px;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(6px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.content-title {
  font-family: 'Merriweather', serif;
  font-size: 32px;
  font-weight: 400;
  color: #1a1a1a;
  margin-bottom: 24px;
}

/* ===== INFO CARDS ===== */
.info-card {
  background: #fff;
  border-radius: 14px;
  padding: 24px 28px;
  margin-bottom: 16px;
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.06);
}

.info-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}

.info-card-title {
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: #000;

  @media screen and (max-width: 768px) {
    font-size: 13px;
  }
}

.edit-link {
  display: flex;
  align-items: center;
  gap: 5px;
  background: none;
  border: none;
  color: #3B6152;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  text-decoration: underline;
  padding: 0;
}

.reset-link {
  color: #3B6152;
  font-size: 13px;
  font-weight: 600;
  text-decoration: underline;
}

/* ===== FORM GRID ===== */
.info-form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0 10px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.form-group.full-width {
  grid-column: 1 / -1;
}

.form-group label {
  font-size: 15px;
  color: #000;
  font-weight: 500;
  margin-bottom: 0;
}

.form-group input {
  border: 1.5px solid #e5e3df;
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 14px;
  color: #000;
  background: #f8f7f5;
  outline: none;
  transition: border-color 0.18s;
}

.birthday-help-text {
  font-size: 12px;
  color: #5d6561;
  line-height: 1.4;
}

.form-group input.editable,
.form-group input:not(:disabled) {
  background: #fff;
  border-color: #d0cec9;
}

.form-group input.editable:focus,
.form-group input:not(:disabled):focus {
  border-color: #3B6152;
}

.gender-group {
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: center;
}

.radio-label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  color: #2d2d2d;
  cursor: pointer;
}

.form-actions {
  display: flex;
  gap: 12px;
  margin-top: 20px;
}

.btn-primary-dashboard {
  background: #3B6152;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 10px 24px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
}

.btn-primary-dashboard:hover {
  background: #2e6049;
}

.btn-secondary-dashboard {
  background: transparent;
  color: #777;
  border: 1.5px solid #ddd;
  border-radius: 8px;
  padding: 10px 24px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: border-color 0.2s;
}

.btn-secondary-dashboard:hover {
  border-color: #999;
}

/* ===== RESERVATIONS ===== */
.resa-filters {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 20px;
  flex-wrap: wrap;
}

.filter-link {
  font-size: 14px;
  color: #3B6152;
  text-decoration: underline;
  font-weight: 500;
  cursor: pointer;
}

.filter-link.active-filter {
  font-weight: 700;
  text-decoration-thickness: 2px;
}

.filter-sep {
  color: #bbb;
  font-size: 13px;
}

.resa-card {
  display: flex;
  align-items: stretch;
  gap: 16px;
  background: #fff;
  border-radius: 14px;
  padding: 16px 20px;
  margin-bottom: 12px;
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.06);
}

.resa-card-image {
  flex-shrink: 0;
  width: 117px;
  height: 103px;
  border-radius: 10px;
  overflow: hidden;
  align-self: center;
}

.resa-card-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.resa-card-body {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.resa-name-row {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  margin-bottom: 4px;
}

.resa-badge {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.5px;
  padding: 3px 10px;
  border-radius: 99px;
}

.badge-upcoming {
  background: #D56A70;
  color: #fff;
}

.badge-past {
  background: #A5D3AE;
  color: #fff;
}

.badge-cancelled {
  background: #bbb;
  color: #fff;
}

.badge-pending {
  background: #E2A44A;
  color: #fff;
}

.resa-address {
  margin: 3px 0 0;
}

.resa-card-bottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.resa-dates {
  margin: 0;
}

.resa-card-actions {
  display: flex;
  gap: 16px;
  flex-shrink: 0;
}

.resa-action-link {
  font-size: 15px;
  color: #3B6152;
  text-decoration: underline;
  font-weight: 600;
  cursor: pointer;
}

.resa-card-price {
  text-align: right;
  flex-shrink: 0;
  align-self: flex-start;
  padding-top: 2px;
}

.resa-price {
  display: block;
  font-size: 15px;
  font-weight: 600;
  color: #000;
}

.resa-price-label {
  font-size: 13px;
  color: #000;
}

/* ===== WISHLIST ===== */
.wishlist-tabs {
  display: flex;
  gap: 4px;
  margin-bottom: 20px;
  background: #f0efed;
  border-radius: 10px;
  padding: 4px;
  width: fit-content;
}

.wl-tab {
  background: transparent;
  border: none;
  padding: 8px 18px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  color: #777;
  cursor: pointer;
  transition: background 0.18s, color 0.18s;
}

.wl-tab.active {
  background: #fff;
  color: #3B6152;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
}

.wish-card {
  display: flex;
  align-items: stretch;
  gap: 16px;
  background: #fff;
  border-radius: 14px;
  padding: 16px 20px;
  margin-bottom: 12px;
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.06);
}

.wish-card-image {
  flex-shrink: 0;
  width: 120px;
  height: 103px;
  border-radius: 10px;
  overflow: hidden;
}

.wish-card-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.wish-card-body {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.wish-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 8px;
}

.wish-name-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 0;
  flex-wrap: wrap;
  flex: 1;
}

.wish-name {
  font-size: 15px;
  font-weight: 600;
  font-family: 'Merriweather', serif;
  color: #000;
}

.wish-stars {
  display: flex;
  align-items: center;
  gap: 1px;
}

.wish-stars img {
  width: 15px;
  height: 15px;
}

.wish-type-badge {
  border: 1px solid #2C5E4B;
  border-radius: 15px;
  color: #2C5E4B;
  height: 20px;
  padding: 13px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: fit-content;
  margin-bottom: 8px;
  font-size: 11px;
}

.wish-location {
  font-size: 15px;
  color: #000;
  margin: 0 0 8px;
}

.wish-map-link {
  color: #3B6152;
  text-decoration: underline;
  cursor: pointer;
  font-weight: 600;
  transition: opacity 0.2s;
}

.wish-map-link:hover {
  opacity: 0.8;
}

.wish-ratings {
  display: flex;
  align-items: center;
  justify-content: end;
  gap: 6px;
}

.wish-ratings img {
  width: 20px;
  height: 24px;
}

.wish-ratings i {
  font-size: 13px;
}

.wish-ratings .link-hortense {
  color: #5D6561;
  text-decoration: underline;
  cursor: pointer;
  margin-left: 4px;
}

.wish-heart-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.wish-heart-btn img {
  width: 20px;
  height: 20px;
}

.wish-heart-btn:hover {
  opacity: 0.8;
}

/* ===== EMPTY STATE ===== */
.empty-state {
  text-align: center;
  padding: 60px 20px;
  background: #fff;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 15px;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.empty-state p {
  font-size: 15px;
  color: #777;
  margin-bottom: 20px;
}

/* ===== MOBILE TOPBAR ===== */
.mobile-topbar {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px 16px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.07);
  margin-top: 9rem;
}

.mobile-menu-btn {
  background: none;
  border: none;
  font-size: 22px;
  cursor: pointer;
  color: #333;
  padding: 0;
  line-height: 1;
}

.mobile-user-info {
  display: flex;
  align-items: center;
  gap: 10px;
}

.mobile-username {
  font-size: 14px;
  font-weight: 700;
  color: #1a1a1a;
}

.mobile-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.35);
  z-index: 99;
}

/* ===== RESPONSIVE ===== */
@media (max-width: 767px) {
  .dashboard-layout {
    flex-direction: column;
    padding: 0;
    gap: 0;
  }

  .sidebar {
    position: fixed;
    top: 0;
    left: -300px;
    width: 280px;
    height: 100vh;
    z-index: 100;
    border-radius: 0 16px 16px 0;
    overflow-y: auto;
    transition: left 0.28s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: 4px 0 24px rgba(0, 0, 0, 0.12);
  }

  .sidebar.sidebar-open {
    left: 0;
    top: 8rem;
  }

  .dashboard-content {
    padding: 20px 0px;
  }

  .content-title {
    font-size: 24px;
  }

  .info-form-grid {
    grid-template-columns: 1fr;
  }

  .form-group.full-width {
    grid-column: 1;
  }

  .resa-card {
    flex-wrap: wrap;
    gap: 12px;
    padding: 12px 10px;
  }

  .resa-card-image {
    width: 100%;
    height: 200px;
    border-radius: 10px;
    overflow: hidden;
    align-self: auto;
  }

  .resa-card-body {
    width: 100%;
  }

  .resa-card-price {
    width: 100%;
    text-align: left;
    border-top: 1px solid #f0efed;
    padding-top: 10px;
    margin-top: 4px;
    align-self: auto;
  }

  .resa-card-bottom {
    width: 100%;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .resa-card-actions {
    width: 100%;
    gap: 8px;
  }

  .resa-action-link {
    display: block;
    padding: 8px 0;
  }

  .wishlist-tabs {
    width: 100%;
  }

  .wl-tab {
    flex: 1;
    text-align: center;
  }

  .wish-card {
    flex-wrap: wrap;
    gap: 12px;
    padding: 12px 10px;
  }

  .wish-card-image {
    width: 100%;
    height: 200px;
    border-radius: 10px;
    overflow: hidden;
    align-self: auto;
  }

  .wish-card-body {
    width: 100%;
  }

  .wish-header {
    justify-content: space-between;
    align-items: center;
    gap: 8px;
  }

  .wish-name-row {
    flex: 1;
    min-width: 0;
  }

  .wish-ratings {
    justify-content: flex-start;
    margin-top: 12px;
  }

  .wish-type-badge {
    font-size: 5px 10px;
    padding: 10px;
    height: fit-content;
  }

  .wish-location {
    font-size: 14px;
  }

  .wish-name {
    font-size: 14px;
  }

  .wish-heart-btn {
    flex-shrink: 0;
  }
}

/* ===== MODALS ===== */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
  /* Allow overlay itself to scroll on very small viewports */
  overflow-y: auto;
}

.modal-box {
  position: relative;
  background: #fff;
  width: 100%;
  max-width: 800px;
  border-radius: 14px;
  padding: 40px 60px;
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.18);
  text-align: center;
  /* Prevent modal from being taller than viewport */
  max-height: 90vh;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  display: flex;
  flex-direction: column;
  animation: modalIn 0.25s ease;
}

@keyframes modalIn {
  from { opacity: 0; transform: translateY(16px); }
  to   { opacity: 1; transform: translateY(0); }
}

.close-button {
  position: absolute;
  top: 1rem;
  right: 1rem;
  width: 32px;
  height: 32px;
  background: #ddd;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  color: #333;
  transition: background 0.2s;
}

.close-button:hover {
  background: #ccc;
}

.modal-box-success {
  max-width: 600px;
}

.modal-title {
  font-family: 'Merriweather', serif;
  font-size: 24px;
  font-weight: 400;
  line-height: 1.4;
  color: #1a1a1a;
  margin-bottom: 30px;
}

.modal-sub {
  font-size: 15px;
  line-height: 1.6;
  color: #000;
  margin-bottom: 30px;
}

.cancel-reasons-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 5px 48px;
  text-align: left;
  margin-bottom: 25px;
}

.reason-label {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 14px;
  color: #2d2d2d;
  cursor: pointer;
}

.reason-radio {
  -webkit-appearance: none;
  appearance: none;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  margin: 0;
  position: relative;
  cursor: pointer;
  background: #fff;
  flex-shrink: 0;
  margin-top: 0.5rem;
}

.reason-radio:checked {
  border-color: #3B6152;
  margin-top: 0.6rem;
}


.cancel-textarea {
  width: 100%;
  background: #F7F7F7;
  border: none;
  border-radius: 8px;
  padding: 15px;
  font-size: 14px;
  font-family: inherit;
  resize: none;
  margin-bottom: 10px;
  outline: none;
}

.btn-confirm-cancel {
  background: #3B6152;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 14px 28px;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.5px;
  cursor: pointer;
  transition: opacity 0.2s;
  text-transform: uppercase;
}

.btn-confirm-cancel:hover {
  opacity: 0.9;
}

.btn-confirm-cancel:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.success-icon-circle {
  width: 64px;
  height: 64px;
  border: 2px solid #3B6152;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 25px;
}

.cancellation-conditions-box {
  background: #E8F5E9;
  border-radius: 8px;
  padding: 16px 20px;
  margin-bottom: 25px;
  text-align: left;
}

.conditions-title {
  font-size: 14px;
  font-weight: 600;
  color: #2C5E4B;
  text-transform: uppercase;
  margin: 0 0 8px;
  letter-spacing: 0.5px;
}

.conditions-text {
  font-size: 14px;
  color: #1a1a1a;
  line-height: 1.5;
  margin: 0;
}

@media (max-width: 640px) {
  .modal-overlay {
    /* On mobile, align to top so scrolling feels natural */
    align-items: flex-start;
    padding: 16px 12px 24px;
  }

  .modal-box {
    padding: 24px 16px;
    border-radius: 14px;
    /* Take up most of the screen height so content is readable */
    max-height: calc(100dvh - 40px);
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }

  .close-button {
    top: 0.75rem;
    right: 0.75rem;
  }

  .cancel-reasons-grid {
    grid-template-columns: 1fr;
    gap: 4px;
    margin-bottom: 18px;
  }

  .modal-title {
    font-size: 18px;
    margin-bottom: 20px;
  }

  .reason-label {
    font-size: 14px;
    padding: 8px 0;
    border-bottom: 1px solid #f0efed;
  }

  .reason-label:last-child {
    border-bottom: none;
  }

  .cancel-textarea {
    margin-bottom: 16px;
    min-height: 80px;
  }

  .cancellation-conditions-box {
    margin-bottom: 16px;
  }
}


@media (min-width: 768px) {
  .mobile-topbar {
    display: none;
  }

  .mobile-overlay {
    display: none;
  }
}

/* ===== CLUB HORTENSE - STATUT & PRIVILÈGES ===== */
.club-subtitle {
  font-family: 'Merriweather', serif;
  font-size: 24px;
  font-weight: 400;
  color: #000;
  margin-bottom: 24px;
}

.club-block {
  margin-bottom: 32px;
}

.club-block-title {
  font-size: 15px;
  font-weight: 600;
  text-transform: uppercase;
  color: #000;
  margin-bottom: 12px;
}

.club-status-hint {
  color: #444;
  margin-bottom: 20px;
  font-size: 15px;
}

/* Gauge (reused from ReservationDetails) */
.loyalty-gauge-container {
  position: relative;
}

.gauge-status-indicator {
  position: absolute;
  bottom: calc(100% + 8px);
  transition: left 0.5s ease-out;
  z-index: 2;
  white-space: nowrap;
}

.bubble-content {
  background: #fff;
  border: 1px solid #2C5E4B;
  padding: 8px 14px;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 120px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}

.bubble-label {
  font-size: 15px;
  font-weight: 600;
  color: #2C5E4B;
  text-transform: uppercase;

  @media screen and (max-width: 768px) {
    font-size: 13px;
  }
}

.bubble-val {
  font-size: 12px;
  font-weight: 500;
  color: #000;
}

.bubble-arrow {
  width: 0;
  height: 0;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-top: 7px solid #2C5E4B;
  margin: 0 auto;
  position: relative;
}

.bubble-arrow::after {
  content: '';
  position: absolute;
  top: -9px;
  left: -6px;
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 6px solid #fff;
}

.gauge-scroll-wrapper {
  width: 100%;
  overflow-x: auto;
}

.scroll-inner {
  width: 100%;
}

.gauge-grid {
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow: visible;
}

.gauge-track {
  position: relative;
  width: 100%;
  height: 13px;
  background: #e0e0e0;
  border-radius: 10px;
  margin-bottom: 24px;
  margin-top: 80px;
  overflow: visible;
}

.gauge-progress {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  background-color: #CFE5DC;
  border-radius: 10px;
  transition: width 0.5s ease-out;
}

.gauge-checkpoint {
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 28px;
  height: 28px;
  background: white;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
}

.gauge-checkpoint i {
  font-size: 13px;
  color: #aaa;
}

.gauge-checkpoint i.fa-check {
  color: #3b6152;
}

.gauge-labels-row {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 0;
  width: 100%;
}

.gauge-section-label {
  display: flex;
  flex-direction: column;
  align-items: center;

  .small {
    font-size: 12px;
    font-weight: 300;
    color: #525252;
    text-align: center;
    font-family: 'Raleway', sans-serif;
  }
}

.guage-label {
  font-family: 'Raleway', sans-serif;
  font-weight: 600;
  font-size: 15px;
  color: #000;
  text-align: center;
  line-height: 1.3;
  min-height: 28px;
}

.guage-sub-label {
  font-family: 'Raleway', sans-serif;
  font-weight: 300;
  font-size: 12px;
  color: #525252;
  text-align: center;
  line-height: 1.3;
}

.gauge-sub-label {
  font-family: 'Raleway', sans-serif;
  font-weight: 300;
  font-size: 12px;
  color: #525252;
  text-align: center;
  line-height: 1.3;
}

/* ===== PRIVILÈGES EN COURS - accordion rows ===== */
.privilege-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 16px 20px;
  background: #fff;
  box-shadow: 0px 3px 6px #00000029;
border-radius: 15px;
  margin-bottom: 10px;
}

.privilege-row-left {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
  min-width: 0;
}

.privilege-code {
  font-size: 15px;
  font-weight: 600;
  color: #3B6152;
  letter-spacing: 0.3px;
}

.privilege-desc {
  font-size: 13px;
  color: #000;
  margin: 0;
}

.privilege-row-right {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-shrink: 0;
}

.privilege-validity {
  font-size: 13px;
  color: #5D6561;
  white-space: nowrap;
}

.privilege-section-label {
  font-size: 15px;
  font-weight: 600;
  color: #3B6152;
  text-transform: uppercase;
  margin-bottom: 10px;
  margin-top: 4px;
}

.privilege-section-label--inactive {
  color: #5D6561;
}

.privilege-row--inactive {
  opacity: 0.7;
}

.privilege-code--inactive {
  color: #5D6561;
}

.privilege-desc--inactive {
  color: #5D6561;
}

.privilege-validity--inactive {
  color: #5D6561;
  font-style: italic;
}

.privilege-toggle {
  background: none;
  border: none;
  cursor: pointer;
  color: #000;
  padding: 4px;
  display: flex;
  align-items: center;
  transition: color 0.15s;
}

.privilege-toggle:hover {
  color: #3B6152;
}

/* ===== CLUB WELCOME BANNER ===== */
.club-welcome-banner {
  background: linear-gradient(135deg, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0.2) 100%),
              url('https://images.unsplash.com/photo-1566073771259-6a8506099945?auto=format&fit=crop&w=1200&q=80');
  background-size: cover;
  background-position: center;
  border-radius: 14px;
  padding: 60px 40px;
  margin-bottom: 32px;
  min-height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.banner-content {
  color: #fff;
}

.banner-greeting {
  font-family: 'Merriweather', serif;
  font-size: 24px;
  font-weight: 400;
  color: #F5EDED;
  margin: 0 0 12px;
  letter-spacing: 0.5px;
}

.banner-title {
  font-family: 'Merriweather', serif;
  font-size: 24px;
  font-weight: 400;
  margin: 0;
  letter-spacing: 0.5px;
}

/* ===== USER RESERVATIONS SECTION ===== */
.user-reservations-section {
  margin-top: 32px;
}

.reservations-title {
  font-size: 15px;
  font-weight: 600;
  text-transform: uppercase;
  color: #000;
  margin-bottom: 20px;
}

.reservations-scroll-container {
  max-height: 400px;
  overflow-y: auto;
  padding-right: 8px;

  @media (max-width: 767px) {
    max-height: 100%;
  }
}

.reservations-scroll-container::-webkit-scrollbar {
  width: 6px;
}

.reservations-scroll-container::-webkit-scrollbar-track {
  background: #3B6152;
  border-radius: 10px;
}

.reservations-scroll-container::-webkit-scrollbar-thumb {
  background: #3B6152;
  border-radius: 10px;
}

.reservations-scroll-container::-webkit-scrollbar-thumb:hover {
  background: #3B6152;
}

.resa-cards-grid::-webkit-scrollbar {
  width: 6px;
}

.resa-cards-grid::-webkit-scrollbar-track {
  background: #3B6152;
  border-radius: 10px;
}

.resa-cards-grid::-webkit-scrollbar-thumb {
  background: #3B6152;
  border-radius: 10px;
}

.resa-cards-grid::-webkit-scrollbar-thumb:hover {
  background: #3B6152;
}



.empty-reservations {
  text-align: center;
  padding: 40px 20px;
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.06);
}

.empty-reservations p {
  font-size: 15px;
  color: #777;
  margin: 0;
}

.reservations-loader {
  padding: 40px 20px;
}

/* ===== NOS OFFRES DU MOMENT - full width section ===== */
.offres-full-section {
  width: 100%;
  padding: 40px 0 60px;
  background: #fff;
}

.offres-full-inner {
  max-width: 90%;
  margin: 0 auto;
  padding: 0 20px;
}

.offres-title {
  font-family: 'Merriweather', serif;
  font-size: 28px;
  font-weight: 400;
  color: #1a1a1a;
  margin-bottom: 28px;
}

/* ===== RESPONSIVE - Club sections ===== */
@media (max-width: 767px) {
   .gauge-scroll-wrapper {
     overflow-x: auto;
     -webkit-overflow-scrolling: touch;
   }

   .scroll-inner {
     min-width: 500px;
   }

   .gauge-grid {
     min-width: 500px;
   }

   .guage-label {
     font-size: 12px;
   }

   .guage-sub-label,
   .gauge-sub-label {
     font-size: 9px;
   }

   .privilege-row {
     flex-direction: column;
     align-items: flex-start;
     gap: 10px;
   }

   .privilege-row-right {
     width: 100%;
     justify-content: space-between;
   }

   .privilege-validity {
     white-space: normal;
   }

   .offres-full-inner {
     max-width: 100%;
     padding: 0 16px;
   }

   .offres-title {
     font-size: 22px;
   }

   .club-subtitle {
     font-size: 18px;
   }

   /* Welcome banner responsive */
   .club-welcome-banner {
     padding: 40px 20px;
     min-height: 160px;
   }

   .banner-greeting {
     font-size: 18px;
     margin-bottom: 8px;
   }

   .banner-title {
     font-size: 18px;
   }

   /* Code card responsive */
   .code-card {
     padding: 16px 20px;
   }

   .code-label {
     font-size: 12px;
   }

   .code-value {
     font-size: 16px;
   }

   .reservations-scroll-container {
     max-height: 350px;
   }
 }

/* ===== RESERVATION EXPERIENCES SECTION ===== */
.reservation-experiences-full-section {
  width: 100%;
  background: #fff;
  padding: 40px 0;
  margin-top: 40px;
}

.reservation-experiences-full-inner {
  max-width: 100%;
  width: 100%;
}

@media (max-width: 767px) {
  .reservation-experiences-full-section {
    padding: 30px 0;
    margin-top: 30px;
  }

  .reservation-experiences-full-inner {
    padding: 0 16px;
  }
}

.resa-cards-grid {
  max-height: 600px;
  overflow-y: auto;

  @media (max-width: 767px) {
    max-height: 100%;
  }
}

.with-box-shadow {
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.06);
  padding: 16px 20px;
  border-radius: 15px;
}

.left-offset-margin {
  margin-left: 4rem;
}
</style>
